const Strings = Object.freeze({
  // ---------------------------- Verkehrsfehler ----------------------------
  INPUT_ERRORS: "Eingabefehler: ",
  OUTPUT_ERRORS: "Ausgabefehler: ",

  CABLE_DELAY: "Kabelverzögerung",
  LINE_DELAY: "Leitungsverzögerung",
  DELAY_POPUP_1: "Zeigt zwei verschiedene Ausbreitungsverzögerungen an (die eine oder die andere, je nach Reaktion des Geräts).",
  DELAY_POPUP_2: "Schwankungen dieser Werte deuten auf physikalische Probleme in der Infrastruktur (Verkabelung und Steckverbinder) hin und können im Falle der \"Leitungsverzögerung\" auf Probleme in den Netzschnittstellen (Sender und Empfänger) hindeuten",
  DELAY_POPUP_3: "Der maximale Richtwert für \"Kabelverzögerung\" beträgt 548 ns.",
  DELAY_POPUP_4: "Die verschiedenen angegebenen Verzögerungen sind:",
  DELAY_POPUP_5: "Ausbreitungsverzögerung nur auf dem verdrahteten Teil;",
  DELAY_POPUP_6: "Beinhaltet Kabel-, Sender- und Empfänger-Ethernet-Verzögerungen",

  IN_ERRORS_POPUP: "Zeigt die Summe aller Pakete an, die mit einer Art von Fehler empfangen wurden. Bei Fehlern dieser Art wird Folgendes vorgeschlagen:",
  OUT_ERRORS_POPUP: "Gibt die Summe aller Pakete an, bei denen eine Art von Fehler auftrat, der die korrekte Übertragung verhinderte. Bei Fehlern dieser Art wird Folgendes vorgeschlagen:",
  SOLVE_ERRORS_POPUP: "Korrekturvorschläge werden in der Aktionsliste angezeigt. Um darauf zuzugreifen, klicken Sie einfach auf die Schaltfläche \"Aktionsliste exportieren\" auf dem Bildschirm TS-Experte",

  TURN_ON: "einschalten",
  TURN_OFF: "ausschalten",
  TURNED_ON_1: "ein",
  MEASUREMENT_INTERVAL: "Messzeitraum",

  DUPLEX_MODE_POPUP: "Gibt den Duplex-Modus der Schnittstelle (Voll- oder Halbduplex) und die Kommunikationsrate an.",

  IN_PACKETS: "Eingehende Pakete",
  OUT_PACKETS: "Ausgehende Pakete",

  ARE_YOU_SURE_YOU_WANT: "Sind Sie sicher, dass Sie das wollen ",
  THE_PORTS_FILTER: "der Anschlussfilter?",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "Beim Einloggen ist ein Fehler aufgetreten: Falscher Benutzername oder falsches Passwort.",
  LOGIN_GENERAL_FALIURE: "Beim Einloggen ist ein Fehler aufgetreten:",
  GPG_ALERT_MESSAGE: "Sie können nur Dateien mit der Endung .gpg versenden",
  XML_ALERT_MESSAGE: "Es ist nur möglich, Dateien mit der Endung .xmlzu senden",
  SEND_FILE_SUCCESS: "Die Datei wurde erfolgreich gesendet",
  SEND_FILES_SUCCESS: "Die Dateien wurden erfolgreich gesendet",
  SEND_FILE_SUCCESS_WARNING: "Vergessen Sie nicht zu überprüfen, ob sich die Netzwerkkarte Ihres Computers im selben Subnetz befindet wie die IP: ",
  SEND_FILE_FAILURE: "Beim Senden der Datei ist ein Fehler aufgetreten",
  SEND_FILES_FAILURE: "Beim Senden der Dateien ist ein Fehler aufgetreten",
  SEND_FILE_WAITING: "Senden der Datei",
  SEND_FILES_WAITING: "Versenden der Dateien",
  SEND_FILE_WRONG_FILENAME: "Ungültiger Name. Die Aktualisierungsdatei sollte den Namen: updatePN.tar.gz.gpg tragen",
  SEND_FILE_CORRUPTED_FILE: "Die Aktualisierungsdatei wurde beim Senden beschädigt",
  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Beim Senden der folgenden GSDML-Dateien ist ein Fehler aufgetreten: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Beim Entfernen der folgenden GSDML-Dateien ist ein Fehler aufgetreten: ",
  SEND_CONFIG_SUCCESS: "Die Einstellungen wurden erfolgreich gesendet",
  SEND_CONFIG_FAILURE: "Beim Senden der Einstellungen ist ein Fehler aufgetreten",
  SEND_NTP_CONFIG_WAITING: "Senden der NTP-Server-Einstellungen",
  SEND_NTP_CONFIG_DONE: "NTP-Server-Einstellungen gesendet",

  SEND_CONFIG_WAITING: "Einstellungen werden gesendet",
  SEND_CONFIG_WAITING_2: "Senden der Einstellungen wird abgeschlossen",
  SEND_CONFIG_DONE: "Einstellungen gesendet",
  SEND_WLAN_CONFIG_WAITING: "Senden der Einstellungen, bitte warten. Dies kann etwa eine Minute dauern",
  UPDATE_WLAN_CONFIG_ERROR: "Es kann keine Verbindung zum WLAN-Netzwerk hergestellt werden. Wenn das Problem weiterhin besteht, versuchen Sie, den Monitor oder den WLAN-Router neu zu starten",
  UPDATE_OFFICE_INTERFACE_CONFIG_ERROR: "Beim Konfigurieren der Office-Schnittstelle ist ein Fehler aufgetreten. Wenn das Problem weiterhin besteht, versuchen Sie, den Monitor oder Router neu zu starten.",

  LOADING_WAITING: "Informationen werden geladen, bitte warten",

  START_MESSAGE_SUCCESS: "Der Monitor wird in 15 Sekunden gestartet.",
  START_MESSAGE_FAILURE: "Beim Starten des Monitors ist ein Fehler aufgetreten.",
  STOP_MESSAGE_SUCCESS: "Der Monitor wird in 15 Sekunden gestoppt",
  STOP_MESSAGE_FAILURE: "Beim Stoppen des Monitors ist ein Fehler aufgetreten",
  WAITING: "Bitte warten Sie einen Moment",
  CLEAN_LOG_SUCCESS: "Das Protokoll wurde erfolgreich geleert",
  CLEAN_LOG_FAILURE: "Beim Bereinigen des Protokolls ist ein Fehler aufgetreten",
  RESET_TRAFFIC_SUCCESS: "Die Werte werden bei der nächsten Abtastung auf Null zurückgesetzt",
  RESET_TRAFFIC_FAILURE: "Beim Zurücksetzen der Fehlerinkremente ist ein Fehler aufgetreten",
  RESET_DEVICES_SUCCESS: "Die Gerätedaten wurden erfolgreich gelöscht",
  RESET_DEVICES_FAILURE: "Beim Löschen von Gerätedaten ist ein Fehler aufgetreten",
  CHANGE_USERNAME_SUCCESS: "Der Benutzername wurde erfolgreich geändert. Bitte melden Sie sich erneut an.",
  CHANGE_USERNAME_FAILURE: "Beim Ändern des Benutzernamens ist ein Fehler aufgetreten: ",
  USERNAME_TOO_SHORT: "Der Benutzername muss mindestens ein Zeichen enthalten.",
  PASSWORD_MISSMATCH: "Die eingegebenen Kennwörter stimmen nicht überein",
  CHANGE_PASSWORD_SUCCESS: "Das Passwort wurde erfolgreich geändert. Bitte melden Sie sich erneut an.",
  CHANGE_PASSWORD_FAILURE: "Beim Ändern des Passworts ist ein Fehler aufgetreten: ",

  VERIFY_THE_FOLLOWING_INFO: "Bitte überprüfen Sie die folgenden Informationen:",
  INVALID_IP: "\n- Die eingegebene IP ist ungültig",
  INVALID_SUBMASK: "\n- Die eingegebene Maske ist ungültig",
  INVALID_GATEWAY: "\n- Das eingegebene Gateway ist ungültig",
  INVALID_DNS: "\n- Der eingegebene DNS ist ungültig",
  LOOPBACK_IP: "\n- Die Loopback-IP (127.0.0.1) kann nicht als Monitor-IP verwendet werden",
  LOOPBACK_IP_NTP: "\n- Die Loopback-IP (127.0.0.1) kann nicht als NTP-Server-IP verwendet werden",
  TAG_TOO_LONG: "\n-Tag-Länge kann 30 Zeichen nicht überschreiten",
  EMPTY_WIFI_PWD: "\n-Wi-fi-Passwort kann nicht leer sein",
  SELECT_TIMEZONE: "\n- Zur Konfiguration des NTP-Servers muss eine Zeitzone ausgewählt werden",
  SAME_SUBNET_IP_1: "\n- Die IP-Adresse der Office-Schnittstelle darf nicht im selben Subnetz liegen wie die PROFINET-Schnittstelle.",
  SAME_SUBNET_IP_2: "\n- Die IP-Adresse der PROFINET-Schnittstelle darf nicht im gleichen Subnetz liegen wie die Office-Schnittstelle.",
  SUBNET_OVERLAP_OFFICE: "\n- Der TS Monitor PROFINET hat eine Überlappung der Adressen zwischen dem PROFINET-Schnittstellen-Subnetz und dem Office-Schnittstellen-Subnetz festgestellt. Aus diesem Grund ist es nicht möglich, die Office-Schnittstelle mit der gewählten IP-Adresse und Maske zu konfigurieren.",
  SUBNET_OVERLAP_PROFINET: "\n- Der TS Monitor PROFINET hat eine Überlappung der Adressen zwischen dem PROFINET-Schnittstellen-Subnetz und dem Office-Schnittstellen-Subnetz festgestellt. Aus diesem Grund ist es nicht möglich, die PROFINET-Schnittstelle mit der gewählten IP-Adresse und Maske zu konfigurieren.",
  SUBNET_OVERLAP_WLAN: "\n- Der TS Monitor PROFINET hat eine Überlappung der Adressen zwischen dem PROFINET-Schnittstellen-Subnetz und dem WLAN-Subnetz festgestellt. Aus diesem Grund ist es nicht möglich, die WLAN mit der gewählten IP-Adresse und Maske zu konfigurieren.",
  SUBNET_OVERLAP_PROFINET_WLAN: "\n- Der TS Monitor PROFINET hat eine Überlappung der Adressen zwischen dem PROFINET-Schnittstellen-Subnetz und dem WLAN-Subnetz festgestellt. Aus diesem Grund ist es nicht möglich, die PROFINET-Schnittstelle mit der gewählten IP-Adresse und Maske zu konfigurieren.",
  ZERO_IP_MSG: "\n- IP 0.0.0.0 kann nicht als IP des Monitors verwendet werden",
  ZERO_IP_MASK_MSG: "\n- Die IP 0.0.0.0 kann nicht als Netzwerkmaske verwendet werden",
  BROADCAST_IP_MSG: "\n- Die Netzwerk-Broadcast-IP kann nicht als IP des Monitors verwendet werden",
  NETWORK_IP_MSG: "\n- Die Netzwerk-IP kann nicht als Monitor-IP verwendet werden",
  BROADCAST_GATEWAY_MSG: "\n- Die Broadcast-IP des Netzwerks kann nicht als Gateway-IP verwendet werden",
  NETWORK_GATEWAY_MSG: "\n- Die Netzwerk-IP kann nicht als Gateway-IP verwendet werden",

  MONITORING_ON: "Ein",
  MONITORING_OFF: "Aus",

  GENERATING_REPORT_WAITING: "Bericht wird erstellt, bitte warten",

  ALTER_USERNAME: "BENUTZER ÄNDERN",
  ALTER_PASSWORD: "PASSWORT ÄNDERN",

  SELECT_FILE: "Bitte wählen Sie eine Datei zum Senden aus",
  SELECT_AT_LEAST_ONE_FILE: "Bitte wählen Sie mindestens eine Datei zum Senden aus",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Bitte wählen Sie mindestens eine zu entfernende Datei aus",

  DO_NOT_CLOSE_THIS_TAB: "Lassen Sie diese Tabelle geöffnet, um die Aktualisierung zu verfolgen",
  UPDATING_MONITOR_FILES: "Aktualisierung von Dateien auf dem Monitor. Bitte warten.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Dateien aktualisiert, Neustart des Monitors vorbereitet.",
  RESTARTING_MONITOR_WAIT: "Neustart des Monitors, bitte warten Sie ein paar Minuten",
  UPDATE_SUCCESS: "Die Aktualisierung wurde erfolgreich durchgeführt!",
  UPDATE_ERROR_STRING: "Beim Aktualisieren des Monitors ist folgender Fehler aufgetreten: ",

  SWEEP_POPUP_MSG: "Ermöglicht eine benutzerdefinierte Scan-Konfiguration für bis zu 5 Subnetze",
  MONITORING_QUESTION_ICON_INFO: "Schaltet das Senden und Erfassen von Nachrichten aktiv ein und aus. Wenn er ausgeschaltet ist, sendet der Monitor keine Nachrichten und erhält keine Daten.",
  DEVICE_SEARCH_QUESTION_ICON_INFO: "Wähle kontinuierliche (konstante) oder einmalige Suche, um das Senden von Nachrichten zu verringern. Im Einzelsuchmodus werden neue Geräte, die im Netzwerk erscheinen, nicht gefunden",
  GSDML_QUESTION_ICON_INFO: "Das Laden von GSDml-Dateien in den TS Monitor erweitert die Möglichkeiten der Anlagendiagnose erheblich, indem es die Interpretation von herstellerspezifischen Informationen ermöglicht, die nur angezeigt werden können, wenn der Monitor diese Dateien geladen hat.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Ändern Sie mindestens eines der Felder, um die Schnittstelleneinstellungen zu aktualisieren",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Ändern Sie mindestens eines der Felder, um die WLAN-Einstellungen zu aktualisieren.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "Das Monitor-Tag wurde erfolgreich geändert.",
  TAG_CHANGE_FAILURE: "Beim Ändern des Monitor-Tags ist ein Fehler aufgetreten",

  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nErinnernSie sich daran, die Adresse im Browser zu aktualisieren: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "Die Schnittstelleneinstellungen wurden erfolgreich aktualisiert!",
  UPDATE_WLAN_CONFIG_SUCCESS: "Die WLAN-Einstellungen wurden erfolgreich aktualisiert!",
  UPDATE_OFFICE_INTERFACE_CONFIG_SUCCESS: "Die Office-Schnittstelleneinstellungen wurden erfolgreich aktualisiert!",

  CONTINUOUS: "Kontinuierlich",
  UNIQUE: "Einzeln",

  ALTER_MONITOR_CONFIG: "Sind Sie sicher, dass Sie die Monitoreinstellungen ändern wollen?",
  RESTART_SYSTEM: "System neu starten",
  CONFIRM_RESTART_SYSTEM: "Sind Sie sicher, dass Sie das System neu starten wollen?",
  RESTART_SYSTEM_FAILURE: "Beim Versuch, das System neu zu starten, ist ein Fehler aufgetreten",
  RESTART_SYSTEM_SUCCESS: "Neustartanforderung erfolgreich gesendet. Bitte warten Sie ca. 3 Minuten, bis das System vollständig neu gestartet wird",

  WI_FI: "Wi-fi",
  MANAGE: "Verwalten",

  TAG_CONFIG: "Netzwerk-Tag",

  ETHERNET: "Ethernet",
  WLAN: "WLAN",

  NTP_SERVER: "NTP-Server",

  TURN_NTP_SERVER_ON: "NTP-Server verbinden",
  TURN_NTP_SERVER_ON_QUESTION: "Sind Sie sicher, dass Sie den NTP-Server einschalten wollen? Dazu muss der Monitor neu gestartet werden.",

  NTP_INFO_TURNED_ON_SUCCESS: "Der NTP-Server wurde erfolgreich verbunden.",
  NTP_INFO_TURNED_ON_FAILURE: "Bei der Verbindung mit dem NTP-Server ist ein Fehler aufgetreten",
  TURN_ON_DATE: "\nDie Serverzeit wurde aktualisiert: ",

  MONITOR_WILL_BE_RESTARTED: "\nDer Monitor wird jetzt neu gestartet,",
  MONITOR_RESTART_SUCCESS: "Der Monitor wurde erfolgreich neu gestartet",
  MONITOR_RESTART_FAILURE: "Beim Neustart des Monitors ist ein Fehler aufgetreten",

  NTP_INFO_TURNED_OFF_SUCCESS: "Der NTP-Server wurde erfolgreich heruntergefahren.",
  NTP_INFO_TURNED_OFF_FAILURE: "Beim Herunterfahren des NTP-Servers ist ein Fehler aufgetreten.",
  TURN_OFF_DATE: "\nAusgangszeit: ",
  NTP_INFO_FAILURE: "Die Synchronisierung mit dem Server ist fehlgeschlagen. Wenn der Fehler weiterhin besteht, wenden Sie sich an den Administrator des NTP-Servers",

  PROCESSING_NTP_INIT: "Beginn der Verarbeitung von Informationen vom NTP-Server",
  PROCESSING_NTP_INFO: "Verarbeitung der Informationen vom NTP-Server",
  PROCESSED_NTP_INFO: "NTP-Server-Informationen verarbeitet",
  PROCESSING_NTP_ERROR: "Beim Senden der Informationen an den NTP-Server ist ein Fehler aufgetreten. Überprüfen Sie, ob die IP-Adresse des Servers korrekt ist. Wenn dies der Fall ist, überprüfen Sie auch, ob der NTP-Dienst eingeschaltet ist, und versuchen Sie es erneut.",

  ETHERNET_CONFIG_POPUP: "Konfigurationsfeld der Ethernet-Schnittstelle, die mit dem Industrienetz verbunden ist und vom TS Monitor zur Datenerfassung verwendet wird.",
  WLAN_CONFIG_POPUP: "Konfigurationsfeld für die drahtlose Schnittstelle, wenn ein Adapter verfügbar ist, der für die Überwachung und den Webzugriff auf TS-Monitor-Daten verwendet wird. Dieses Netz ist vom Ethernet/Industrienetz isoliert",
  OFFICE_CONFIG_POPUP: "Konfigurationsfeld für die Ethernet-Schnittstelle, die für die Überwachung und den Webzugriff auf TS Monitor-Daten verwendet wird. Dieses Netzwerk ist vom Ethernet-/Industrienetzwerk isoliert.",
  BLACKLIST_CONFIG_POPUP: "Ermöglicht den Ausschluss einiger Datenerfassungsdienste aus dem TS-Monitor.",
  TS_EXPERT_CONFIG_POPUP: "Ermöglicht die Aktivierung/Deaktivierung der Meldung von Nichtkonformitäten durch das Tool",

  ALTER: "Ändern",
  USER: "Benutzer",
  NEW_PWD: "Neues Passwort",
  REPEAT_PWD: "Passwort wiederholen",
  REASON_DP: "Grund: ",
  TEST_NETWORK: "Testnetz",
  EDIT: "Bearbeiten",
  SWEEP: "Scannen",
  DEVICE_SEARCH: "Gerätesuche",
  SOFTWARE_UPDATE: "Software-Aktualisierung",
  CURRENT_VERSION: "Aktuelle Version: ",
  UPDATE: "Aktualisierung",
  GSDML_FILES: "GSDML-Dateien",
  SEND: "Senden",
  CLEAR: "Reinigen",
  TRAFFIC_ERROR_INCREMENT: "Erhöhter Verkehrsfehler",
  REPORT: "Bericht",
  ALTER_LOGIN: "Anmeldung ändern",
  INTERFACE_CONFIG: "Schnittstelleneinstellungen",
  INTERFACE_PROFINET_CONFIG: "PROFINET-Schnittstelleneinstellungen",
  ENTER: "Eingabe",

  SNMP_MODE: "SNMP-Modus",
  SNMP_MODE_QUESTION_ICON_INFO_1: "Wenn Sie beim Platzieren des TS Monitor PROFINET im Netzwerk feststellen, dass einige Geräte nicht ordnungsgemäß funktionieren, können Sie den langsamen SNMP-Modus aktivieren.",
  SNMP_MODE_QUESTION_ICON_INFO_2: "Durch Aktivieren dieses Modus wird die Rate, mit der SNMP-Anfragen gesendet werden, erheblich verringert, wodurch das Problem möglicherweise gelöst wird.",
  SNMP_MODE_FAST: "Schnell",
  SNMP_MODE_SLOW: "Langsam",
  SNMP_MODE_WAS_CHANGED_SUCCESSFULLY: "Der SNMP-Modus wurde erfolgreich geändert.",
  SNMP_MODE_CHANGE_FAILURE: "Beim Ändern des SNMP-Modus ist ein Fehler aufgetreten.",

  PROFINET_INTERFACE: "Ethernet-Schnittstelle",
  OFFICE_INTERFACE: "Office-Schnittstelle",

  // ---------------------------- Sweep Page ----------------------------
  PERSONALIZED_SWEEP: "Personalisierter Scannen",

  SWEEP_ON: "Ein",
  SWEEP_OFF: "Aus",
  BANDS: "Bereich",

  FIRST_BAND: "1. Bereich",
  SECOND_BAND: "2. Bereich",
  THIRD_BAND: "3. Bereich",
  FOURTH_BAND: "4. Bereich",
  FIFTH_BAND: "5. Bereich",

  BEGINNING: "Beginn",
  END: "Ende",

  ALERT_MESSAGE_PLACEHOLDER: "Die Felder der folgenden Bänder haben Probleme: ",

  FIRST_SUBNETWORK_ADDRESS_NOT_VALID: "\n-Die Adresse vom ersten Bereich ist nicht gültig",
  FIRST_SUBNETWORK_START_LESS_THAN_FINISH: "\n - Die Startadresse vom ersten Bereich ist größer oder gleich dem Ende",
  FIRST_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - Der erste Bereich hat leere Felder",

  SECOND_SUBNETWORK_ADDRESS_NOT_VALID: "\n-Die Adresse vom 2. Bereich ist nicht gültig",
  SECOND_SUBNETWORK_START_LESS_THAN_FINISH: "\n - Die Startadresse vom zweiten Bereich ist größer oder gleich dem Ende",
  SECOND_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - Der zweite Bereich hat leere Felder",

  THIRD_SUBNETWORK_ADDRESS_NOT_VALID: "\n-Die Adresse vom 3. Bereich ist nicht gültig",
  THIRD_SUBNETWORK_START_LESS_THAN_FINISH: "\n - Die Startadresse vom dritten Bereich ist größer oder gleich dem Ende",
  THIRD_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - Der 3. Bereich hat unausgefüllte Felder",

  FOURTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - Die Adresse vom vierten Bereich ist nicht gültig",
  FOURTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - Die Startadresse vom vierten Berecih ist größer oder gleich dem Ende",
  FOURTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - Der 4. Bereich hat unausgefüllte Felder",

  FIFTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - Die Adresse vom 5. Bereich ist nicht gültig",
  FIFTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - Die Startadresse vom 5. Bereich ist größer als oder gleich dem Ende",
  FIFTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - Der 5. Bereich hat nicht ausgefüllte Felder",

  SWEEP_DATA_SENT_SUCCESSFULLY: "Die Scan-Einstellungen wurden erfolgreich gespeichert.",
  SWEEP_DATA_SENT_ERROR: "Beim Speichern der Scan-Einstellungen ist ein Fehler aufgetreten",
  SPECIFY_AT_LEAST_ONE_SUBNETWORK: "Sie müssen mindestens ein Subnetz angeben, um den benutzerdefinierten Scan zu speichern.",

  UNABLE_TO_SAVE_CUSTOM_SWEEP: "Benutzerdefinierter Scan kann nicht gespeichert werden, weil:",
  _THE: "- Bereich ",
  BAND_HAS_IPS_NOT_IN_SUBNETWORK: "ª Band enthält IPs, die sich nicht im Monitorsubnetz befinden",
  SENDING_DATA: "Daten senden",

  // ---------------------------- PDF Report ----------------------------
  REPORT_EXPORT_NAME_PDF: "Bericht TS Monitor PROFINET.pdf",
  FINISHING: "Finalisieren...",
  SAVE_REPORT: "Bericht speichern",

  PROJECT_NAME_1: "Projektname",
  LOCATION_1: "Standort",
  COMPANY_NAME_1: "Name des Unternehmens",
  RESPONSIBLE_NAME: "Name der verantwortlichen Person",
  ADDRESS: "Adresse",
  CITY: "Stadt",
  TEL: "Telefon",
  CLIENT_LOGO: "Das Logo des Kunden",
  EMAIL: "E-Mail",
  EXECUTING_COMPANY_LOGO: "Logo des ausführenden Unternehmens",

  GENERAL_INFO_TITLE: "1. Überblick",
  LIVE_LIST_TITLE: "2. Live-Liste",
  TOPOLOGY_TITLE: "3. Topologie",
  TRAFFIC_INPUT_TITLE: "4. Fehler im eingehenden Verkehr",
  TRAFFIC_OUTPUT_TITLE: "5. ausgehende Verkehrsfehler",
  LOG_PAGE_TITLE: "6. Ereignisprotokoll",

  ACTIVE_TYPE: "AKTIV",
  NOT_ACTIVE_TYPE: "NICHT AKTIV",

  CONFORM_STRING: "Konform",
  CONFORM_W_RESTRICTION_STRING: "Konform mit Einschränkungen",
  NON_CONFORM_STRING: "Nicht übereinstimmend",

  GENERATING_REPORT_SUCCESS: "Bericht erfolgreich erstellt. Um ihn zu speichern, klicken Sie unten auf Bericht speichern",

  CONFORMITY: "Konformität",
  DROPDOWN_PLACEHOLDER: "Wählen Sie eine Option",
  GENERATE_REPORT: "Bericht generieren",
  CLIENT_INFO: "Kundeninformationen",
  EXECUTING_COMPANY_INFO: "Informationen über das ausführende Unternehmen",
  ANNOTATIONS: "Anmerkungen",
  CONCLUSION: "Schlussfolgerung",

  HEADER_TEXT: "Datenbericht - PROFINET TS Monitor",
  REPORT_EXPORT_NAME: "PROFINET Monitor TS Bericht",

  GENERAL_REPORT: "Allgemeiner Bericht - PROFINET TS Monitor",
  DATA_REPORT: "Datenbericht - PROFINET Monitor TS",

  PROJECT_NAME: "- Projektname:",
  NETWORK_NAME: "- Netzwerkname:",
  LOCATION: "- Standort:",
  COMPANY_NAME: "- Name des Unternehmens:",
  ACCOUNTABLE_NAME: "- Name der verantwortlichen Person:",
  COMPANY_ADDRESS: "- Adresse:",
  COMPANY_CITY: "- Stadt:",
  COMPANY_TEL: "- Telefon:",

  EXECUTING_COMPANY_NAME: "- Firmenname:",
  EXECUTING_ACCOUNTABLE_NAME: "- Name der verantwortlichen Person:",
  EXECUTING_TEL: "- Telefon:",
  EXECUTING_EMAIL: "- E-Mail:",

  MONITORING_INFO: "Informationsüberwachung",
  ETHERNET_INFO: "ETHERNET-Informationen",
  WLAN_INFO: "WLAN-Informationen",
  ETHERNET_OFFICE_INFO: "ETHERNET Office-Informationen",

  NETWORK_TAG_DP: "- Netzwerk-Tag: ",
  NETWORK_NAME_DP: "- Netzwerkname: ",
  MONITOR_IP_DP: "- Monitor IP: ",
  MONITOR_SUBMASK_DP: "- Monitor-Maske: ",
  MONITOR_VERSION_DP: "- Monitor-Version: ",
  MONITOR_TIME_ON_DP: "- Zeit Ein: ",
  MEASUREMENT_INTERVAL_DP: "- Messzeitraum: ",
  REPORT_GENERATION: "- Erstellung des Berichts: ",

  IP_DP: "- IP: ",
  MASK_DP: "- Maske: ",
  GATEWAY_DP: "- Gateway: ",
  DNS_DP: "- DNS: ",
  MODO_DP: "- Konfigurationsmodus: ",

  SUMMARY: "Zusammenfassung",
  OVERVIEW: "Überblick",
  LIVE_LIST: "Live-Liste",
  INVENTORY: "Vorräte",
  TOPOLOGY: "Topologie",
  GRAPHIC_TOPOLOGY: "Grafische Topologie",
  IN_TRAFFIC_ERRORS: "Fehler im eingehenden Verkehr",
  OUT_TRAFFIC_ERRORS: "Fehler im ausgehenden Verkehr",
  LOG: "Log",
  CONFIG: "Einstellungen",
  DISCLAIMER: "Rechtlicher Hinweis",

  M_MONITORING_OVERVIEW_PAGE_TITLE: "1. - Überblick",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "2. - Live-Liste",
  M_MONITORING_INVENTORY_PAGE_TITLE: "3. - Inventar",
  M_MONITORING_TOPOLOGY_PAGE_TITLE: "4. - Topologie",
  M_MONITORING_IN_TRAFFIC_ERRORS_PAGE_TITLE: "5. - Fehler im eingehenden Verkehr",
  M_MONITORING_OUT_TRAFFIC_ERRORS_PAGE_TITLE: "6. - Fehler im ausgehenden Verkehr",
  M_MONITORING_LOG_PAGE_TITLE: "7. - Ereignisprotokollierung",

  TS_MONITOR_VER_DP: "TS PROFINET Monitor - Version ",
  NETWORK_STATUS_DP: "Netzwerkstatus: ",
  DEVICE_DATA: "Gerätedaten",

  CONTROLLERS_DP: "IO-Controller: ",
  DEVICES_DP: "IO-Geräte: ",
  SUPERVISORS_DP: "Supervisors: ",
  SUPERVISORS: "Supervisors",
  OTHER_DEVICES_DP: "Kein PROFINET: ",
  OTHER_DEVICES: "Nicht PROFINET",
  FAULTS_DP: "Fehler: ",
  ALARMS_DP: "Alarme: ",
  IN_TRAFFIC_DP: "Eingehender Ethernet-Verkehr: ",
  OUT_TRAFFIC_DP: "Ausgehender Ethernet-Verkehr: ",
  NETWORK_AVAILABILITY_DP: "Netzverfügbarkeit: ",

  NAME: "Name",
  MODEL: "Modell",
  MAC: "MAC",
  MACS: "MACs",
  IP: "IP",
  IPS: "IPs",
  FUNCTION: "Funktion",
  STATUS: "Status",
  ON_TIME: "Zeit EIN",
  EVENT_TYPE: "Art des Ereignisses",

  MONITORING_BLACKLIST_STRING: "Schwarze Liste überwachen",
  MONITORING_BLACKLIST_STRING_1: "Schwarze Liste von",
  MONITORING_BLACKLIST_STRING_2: "Überwachung",
  OFFLINE_STRING: "Offline",
  ONLINE_STRING: "Online",
  FAULT_STRING: "Störung",
  DUPLICATE_IP_STRING: "Doppelte IP",
  CONFIG_ERROR_STRING: "Konfigurationsfehler",

  BLACKLIST_OK_STRING: "Schwarze Liste - OK",
  BLACKLIST_ALARM_STRING: "Schwarze Liste - Alarm",
  BLACKLIST_OFFLINE_STRING: "Schwarze Liste - Offline",
  BLACKLIST_ONLINE_STRING: "Schwarze Liste - Online",
  BLACKLIST_FAULT_STRING: "Schwarze Liste - Fehlgeschlagen",
  BLACKLIST_DUPLICATE_IP_STRING: "Schwarze Liste - Doppelte IP",
  BLACKLIST_CONFIG_ERROR_STRING: "Schwarze Liste - Konfigurationsfehler",

  SNMP: "SNMP",
  PORT: "Anschluss",
  NEIGHBOUR_NAME: "Nachbar-Name",
  NEIGHBOUR_PORT_1: "Tür",
  NEIGHBOUR_PORT_2: "Nachbar",
  NEIGHBOUR_IP: "Nachbar-IP",

  LAST_200_EVENTS: "Die letzten 200 Ereignisse",
  DESCRIPTION: "Beschreibung",
  HORARY: "Uhrzeit",

  END_OF_REPORT: "Ende des Berichts",
  DISCLAIMER_TEXT: "Die in diesem Bericht dargestellten Daten und Werte sind lediglich Hilfsmittel für den PROFINET-Spezialisten, so dass jeder Hinweis auf eine Korrektur durch den Anwender erfolgen muss. Aus diesem Grund wird empfohlen, dass ein PROFINET-zertifizierter Ingenieur oder Techniker, der für die Analyse verantwortlich ist, anwesend ist, um die vom Produkt gelieferten Informationen zu bestätigen. Daher lehnt Toledo & Souza jegliche Verantwortung, Verluste oder Schäden ab, die direkt oder indirekt durch die Interpretation der Software verursacht werden. Toledo & Souza bietet keine Garantie für die Integrität, Qualität oder Angemessenheit der bereitgestellten Informationen, da diese von der technischen Analyse eines ausgebildeten Fachmanns abhängen, und in Ermangelung eines solchen übernimmt der Benutzer das Risiko, dass der Inhalt ungenau oder unvollständig ist oder nicht seinen Bedürfnissen und Anforderungen entspricht",

  NO_INPUT_TRAFFIC_ERRORS: "Das Netz hat keine Fehler im eingehenden Verkehr",
  NO_OUTPUT_TRAFFIC_ERRORS: "Das Netz hat keine Fehler im ausgehenden Verkehr",

  DEVICE_HAS_JOINED_THE_NETWORK: "Das Gerät hat sich dem Netz angeschlossen",
  DETAILS: "Details:",

  PAGE: "Seite",
  INPUT: "Eingabe",
  OUTPUT: "Ausgang",
  ERRORS_IN: "Fehler",
  PORT_STATUS: "Hafenstatus",
  REPORTING: " reporting:",
  TIP: "Tipp:",
  THE_DEVICE: "Das Gerät",
  OF_IP: "von IP",
  JOINED_THE_NETWORK: "ist dem Netz beigetreten",
  THE_PORT: "Die Tür",
  IS_CONNECTED_WITH_PORT: "es ist mit dem Anschluss verbunden",
  FROM_DEVICE: "vom Gerät",

  // ---------------------------- Alarms ----------------------------
  ACTIVE_DP: "Aktiv:",
  NOT_ACTIVE_DP: "Nicht aktiv:",
  ALARM: "Alarm",
  ALARMS: "Alarme",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Vor dem letzten Start",
  REMOVE_DEVICE_SUCCESS: "Das Gerät wird innerhalb von 30 Sekunden entfernt",
  REMOVE_DEVICE_FAILURE: "Beim Entfernen des Geräts ist ein Fehler aufgetreten: ",

  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "Mit Alarm",
  WITH_FAILURE_STRING: "Mit Fehler",
  UNKNOWN: "Unbekannt",
  NO_ANSWER: "Keine Antwort",
  NO_EVENT: "Kein Ereignis",
  LOG_WAITING: "Laden der Protokolldaten",
  GO_TO_LOG_OR_REMOVE_POSITIONING: "Zum Protokoll gehen oder Gerät löschen",
  ASK_DELETE_OR_LOG: "Möchten Sie zur Protokollseite gehen oder das Gerät aus der Liste löschen?",
  DELETE: "Löschen",
  GO_TO_LOG: "Gehe zum Protokoll",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filter nach IP, MAC, Name oder Status",
  TOPOLOGY_INPUT_TEXT_PLACEHOLDER: "Filter nach IP, Name oder Modell",
  TRAFFIC_INPUT_TEXT_PLACEHOLDER: "Filter nach IP oder Name",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filter nach Name, Modell oder IP",
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Nach IP, Tag oder Profiname suchen",
  PING_INPUT_TEXT_PLACEHOLDER: "Filter nach IP oder MAC",
  FAULTS: "Misserfolge",
  ACTUAL_MEDIUM: "Aktuell / Mittel",
  AVAILABILITY: "Verfügbarkeit",
  STATISTICS: "Statistik",
  BILLIONS_OF: "Milliarden von",
  ONE_MILLION_OF: "Million von",
  ONE_BILLION_OF: "Milliarden von",
  MILLIONS_OF: "Millionen von",
  THOUSAND: "Tausend.",
  THOUSAND_NO_CAPITAL: " Tausend",
  MILLION_NO_CAPITAL: " Million",
  MILLIONS_NO_CAPITAL: " Million",
  BILLION_NO_CAPITAL: "Milliarden",
  BILLIONS_NO_CAPITAL: "Milliarden",
  LAST_EVENT: "Letztes Ereignis: ",
  UP_TIME: "Betriebszeit:",
  MONITORING: "Überwachung",
  TURNED_OFF: "Aus",
  TURNED_ON: "Ein",
  MONITORING_ON_TOOLTIP: "Überwachungsdienst eingeschaltet",
  MONITORING_OFF_TOOLTIP: "Überwachungsdienst ausgeschaltet. Um den Dienst zu aktivieren, öffnen Sie das Fenster ÜBERWACHUNG auf der Tabelle Einstellungen",
  MONITORING_GETTING_CONNECTION: "Verbindung wird hergestellt",
  ZERO_IP: "0.0.0.0",

  ALARMS_QUESTION_INFO: "Zeigt die Anzahl der von den Geräten beantworteten Alarme an. Alarme zeigen anormale Gerätezustände an, wie z. B. Kurzschluss, Stromversorgungsprobleme, fehlendes Modul usw.",
  FAULTS_QUESTION_INFO: "Gibt an, wie oft ein bestimmtes PROFINET-Gerät nicht auf die vom TS-Monitor gesendeten Nachrichten geantwortet hat.",

  AVAILABILITY_QUESTION_INFO_1: "Gibt den Prozentsatz der Zeit an, in der das Gerät im Netz erkannt wurde, d. h. über das Netz erreichbar war",
  AVAILABILITY_QUESTION_INFO_2: "Dieser Parameter berücksichtigt keine anderen Bedingungen, wie z.B. ob das Gerät funktionierte oder nicht, sondern nur die Tatsache, dass es auf den TS Monitor geantwortet hat.",

  SHOW_ONLY_ERROR_DEVICES: "Nur Geräte mit Fehlern anzeigen",

  PORTS_FILTER_LABEL: "Anschlussfilter",
  PORTS_FILTER_POPUP_1: "Einige Geräte weisen Paketverluste an internen Anschlüssen auf, für die es keine Korrekturmöglichkeiten durch den Benutzer gibt, und liefern keine relevanten Informationen für die Analyse des Netzwerks selbst.",
  PORTS_FILTER_POPUP_2: "Der Filter eliminiert diese Anschlüsse, jedoch können Anschlüsse mit ungewöhnlichen Namen eliminiert werden und aus diesem Grund kann der Filter ausgeschaltet werden, um eine vollständige Anzeige zu ermöglichen.",

  PORTS_FILTER_TURN_ON_FAILURE: "Beim Einschalten des Anschlussfilters ist ein Fehler aufgetreten.",
  PORTS_FILTER_TURN_OFF_FAILURE: "Beim Ausschalten des Anschlussfilters ist ein Fehler aufgetreten",

  DEVICE: "Gerät",

  LIVE_LIST_OK_POPUP_TEXT: "Gerät im Normalbetrieb, d.h. Datenaustausch",
  LIVE_LIST_DIAGNOSTIC_POPUP_TEXT: "Gerät im normalen Betriebsmodus hat eine Diagnosebedingung gemeldet.",
  LIVE_LIST_FAULT_POPUP_TEXT: "Gerät, das sich im normalen Betriebsmodus (OK) befand, kommuniziert nicht mehr auf dem PROFINET-Netzwerk, es ist also ausgefallen.",
  LIVE_LIST_ONLINE_POPUP_TEXT: "Gerät befindet sich physikalisch im PROFINET-Netzwerk und tauscht keine Daten mit der Steuerung aus. Dieses Verhalten ist darauf zurückzuführen, dass das Gerät im IO-Controller-Projekt nicht aktiv oder konfiguriert ist.",
  LIVE_LIST_OFFLINE_POPUP_TEXT: "Ethernet-Gerät, das vom Netz getrennt wurde",
  LIVE_LIST_DUPLICATE_IP_POPUP_TEXT: "Wenn mehr als ein Gerät die gleiche IP-Adresse hat",
  LIVE_LIST_DUPLICATE_IP_POPUP_TEXT_2: "Durch Klicken auf die Zelle können Sie das Gerät löschen, wenn Sie möchten.",
  LIVE_LIST_BLACKLIST_POPUP_TEXT: "Der Benutzer kann ein IO-Gerät in den Blacklist-Modus versetzen, um keine sich wiederholenden Ereignisse im Log zu erzeugen",
  LIVE_LIST_CONFIG_ERROR_POPUP_TEXT: "Gerät mit unterschiedlichen ID-Nummern zwischen einem konfigurierten und dem physisch installierten Modul (Informationen aus der GSDml des Geräts). Die Beschreibung ist im Protokoll ausführlicher dargestellt.",

  LIVE_LIST_CSV_HEADER: "Name,Tag,MAC,IP,Alarme,Fehler,Aktueller Ping (ms),Durchschnittlicher Ping (ms),Verlorene Pings,Verlorene Pings (%),Verfügbarkeit,Status\n",
  LIVE_LIST_CSV_EXPORT_NAME: "Live List.xlsx",

  PS: "Notiz:",

  IP_POPUP_2: "Wenn das Gerät seine IP-Adresse verliert, wird es wie im folgenden Beispiel orange hinterlegt.",
  IP_POPUP_3: "Darüber hinaus können Sie durch Klicken auf die Zelle das Gerät löschen, wenn Sie möchten.",

  REMOVE_LOST_IP_MODAL_HEADER: "Entfernen Sie das Gerät mit IP-Adressverlust",
  REMOVE_LOST_IP_MODAL_CONTENT_1: "Möchten Sie das Gerät mit der IP-Adresse 0.0.0.0 wirklich entfernen?",
  REMOVE_LOST_IP_MODAL_CONTENT_2: "Sollte das Gerät immer noch einen Verlust der IP-Adresse aufweisen, wird es im nächsten TS Monitor PROFINET-Suchzyklus wieder zur Live List hinzugefügt.",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  SAVE_TOPOLOGY_POS_STRING: "Speichern",
  DELETE_TOPOLOGY_POS_STRING: "Entfernen",
  EXPORT_SVG: "SVG",
  EXPORT_TOPOLOGY: "Topologie",
  IMPORT_TOPOLOGY: "Topologie importieren",
  IMPORT: "Importieren",
  EXPORT_PNG: "PNG",
  POSITION: "Position",
  EXPORT: "Exportieren",
  FILTER: "Filter",
  EXPORT_SVG_POPUP_MSG: "Um das Topologiebild im SVG-Format zu exportieren, muss zuerst die Topologieposition gespeichert werden",

  HIGHER_THAN_20_MBPS: "> 20 Mbps",
  HIGHER_THAN_50_MBPS: "> 50 Mbps",
  WITH_ERROR: "Mit Fehler",
  WITH_ERROR_INCREMENT: "Mit &Delta; Fehler",
  LEGEND: "Legende",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "Die Topologiepositionierung wurde erfolgreich gespeichert!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "Beim Speichern der Topologiepositionierung ist folgender Fehler aufgetreten: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "Die Topologiepositionierung wurde erfolgreich entfernt!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "Beim Entfernen der Topologiepositionierung ist folgender Fehler aufgetreten: ",

  DROPDOWN_NONE: "Keine",
  DROPDOWN_TRAFFIC: "Verkehr",
  DROPDOWN_ERRORS: "Fehler",

  ASK_REMOVE_POSITIONING: "Sind Sie sicher, dass Sie die gespeicherte Positionierung entfernen wollen? Um die Entfernung zu bestätigen, müssen Sie Ihre Anmeldedaten eingeben.",
  REMOVE_POSITIONING: "Positionierung entfernen",
  GRAPHIC_TOPOLOGY_WAITING: "Laden der grafischen Topologie",
  YES: "Ja",
  NO: "Nein",
  USERNAME_PWD_EMPTY: "Der Benutzername und das Passwort dürfen nicht leer sein.",

  FORM_INPUT_NOT_FOUND_1: "Das IP-Gerät: ",
  FORM_INPUT_NOT_FOUND_2: " wurde nicht gefunden",
  FORM_INPUT_INVALID_IP: "Geben Sie eine gültige IP-Adresse ein",

  DUPLICATE_IPS: "Die grafische Topologie konnte nicht geladen werden, weil das Netz doppelte IPs enthält.",

  DISCONNECTED_PORT_1: "Der ausgewählte Anschluss ",
  DISCONNECTED_PORT_2: " des Geräts ",
  DISCONNECTED_PORT_3: " ist nicht mehr verbunden",

  TOPOLOGY_IMPORT_SUCCESS: "Die Topologie wurde erfolgreich importiert!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "Beim Importieren der grafischen Topologie ist ein Fehler aufgetreten: ",
  INVALID_OR_CORRUPT_FILE: "Die Datei ist ungültig oder beschädigt",
  PLEASE_SELECT_TOPOLOGY_FILE: "Bitte wählen Sie eine Topologiedatei aus",

  GRAPHIC_TOPOLOGY_POPUP_1: "Die grafische Topologie wird automatisch anhand der von den Netzwerkgeräten empfangenen Informationen erkannt und zeigt den Status der Geräte entsprechend den LiveList-Farben an; die Verbindungen zwischen den Geräten wechseln von blau zu orange, wenn sie eine Fehlerzunahme aufweisen.",
  GRAPHIC_TOPOLOGY_POPUP_2: "Einige Geräte reagieren nicht auf SNMP-Befehle, die für diese Erkennung verwendet werden, so dass nicht alle in der LiveList angezeigten Geräte in der grafischen Topologie vorhanden sind",
  GRAPHIC_TOPOLOGY_POPUP_3: "Die verschiedenen angezeigten Symbole hängen von der Einbeziehung der GSDml-Konfigurationsdateien in der Registerkarte \"Einstellungen\" des TS-Monitors ab (diese Datei muss dem im Netz vorhandenen Gerät entsprechen, andernfalls wird das dem Typ entsprechende Symbol nicht angezeigt).",
  GRAPHIC_TOPOLOGY_POPUP_4: "Die Positionen der Geräte können geändert werden, aber es ist nicht möglich, die Verbindung zwischen ihnen zu ändern oder Geräte hinzuzufügen.",

  NAME_DP: "Name: ",
  MODEL_DP: "Modell: ",
  PROFINET_TOPOLOGY_JSON: "PROFINET Topology.json",

  // ---------------------------- Log ----------------------------
  ALARM_FAILURE_TOOLTIP: "Die Wartung muss jetzt durchgeführt werden. Das Gerät funktioniert nicht mehr.",
  ALARM_MAINTENANCE_DEMANDED_TOOLTIP: "Die Wartung sollte so schnell wie möglich durchgeführt werden.",
  ALARM_MAINTENANCE_REQUIRED_TOOLTIP: "Das Gerät benötigt prädiktive Wartung.",
  ALARM_NONE_TOOLTIP: "Schweregrad nicht gemeldet.",
  INSERT_VALID_EVENT_OR_NAME_OR_IP: "Bitte geben Sie ein gültiges Ereignis, einen Namen oder eine IP ein",
  MANUFACTURER_TIP: " (Hersteller-Tipp:",
  FROM_GSDML: "Von GSDML: ",
  STATUS_CHANGE: "Änderung des Status: ",
  DUPLICATE_IP: "Doppelte IP: ",
  DUPLICATE_NAME_DP: "Duplizierter Profiname: ",

  // ---------------------------- BLACKLIST ----------------------------
  UPDATE_BLACKLIST_DEVICES: "Geräte von der schwarzen Liste aktualisieren",
  CONFIRM_UPDATE_BLACKLIST_MODAL_TEXT: "Sind Sie sicher, dass Sie die Geräte auf der schwarzen Liste aktualisieren wollen?",

  ADD_DEVICES_TO_BLACKLIST: "Geräte zur schwarzen Liste hinzufügen",
  REMOVE_DEVICES_FROM_BLACKLIST: "Geräte von der schwarzen Liste entfernen",
  BLACKLIST_FORM_INPUT_PLACEHOLDER: "Geräte nach Name, MAC oder IP filtern",
  BLACKLIST_NAME: "Name",
  BLACKLIST_MODEL: "Modell",
  BLACKLIST_MAC: "MAC",
  BLACKLIST_IP: "IP",
  SELECT_ALL: "Alles auswählen",
  REMOVE_SELECTED: "Ausgewählte entfernen",
  ADD_SELECTED: "Ausgewählte hinzufügen",
  ADD_DEVICES_TO_BLACKLIST_SUCCESS: "Die Geräte wurden erfolgreich zur schwarzen Liste hinzugefügt",
  ADD_DEVICES_TO_BLACKLIST_FAILURE: "Beim Hinzufügen der folgenden Geräte zur schwarzen Liste ist ein Fehler aufgetreten:",
  REMOVE_DEVICES_FROM_BLACKLIST_SUCCESS: "Die Geräte wurden erfolgreich von der schwarzen Liste entfernt",
  REMOVE_DEVICES_FROM_BLACKLIST_FAILURE: "Beim Entfernen der folgenden Geräte von der schwarzen Liste ist ein Fehler aufgetreten:",
  SELECT_AT_LEAST_ONE_DEVICE: "Wählen Sie mindestens ein Gerät aus, das der schwarzen Liste hinzugefügt werden soll.",
  CONFIRM_ADD_TO_BLACKLIST_MODAL_TEXT: "Sind Sie sicher, dass Sie die ausgewählten Geräte zur schwarzen Liste hinzufügen wollen?",
  CONFIRM_REMOVE_FROM_BLACKLIST_MODAL_TEXT: "Sind Sie sicher, dass Sie die ausgewählten Geräte von der schwarzen Liste entfernen wollen?",
  IGNORE: "Ignorieren",
  LOG_IGNORE: "Log",
  QUESTION_IGNORE: "Überwachung",
  FAULTS_IGNORE: "Fehler",
  ALARMS_IGNORE: "Alarme",
  AVAILABILITY_IGNORE: "Verfügbarkeit",
  SNMP_IGNORE: "SNMP",

  UPDATE_BLACKLIST: "Schwarze Liste aktualisieren ",
  UPDATING_BLACKLIST_WAITING: "Aktualisierung der schwarzen Liste, bitte warten Sie einen Moment",
  UPDATING_BLACKLIST_SUCCESS: "Die schwarze Liste wurde erfolgreich aktualisiert",
  BLACKLIST: "Schwarze Liste",

  WHAT_DOES: "Was es tut: ",
  HOW_DOES_IT_APPLY: "Wie zutreffend: ",

  DELTA_ERRORS_TOOLTIP_WHAT: "Prüft in TS Expert nicht, ob dieses Gerät eine Fehlerinkrementierung hat, zählt aber trotzdem in der Registerkarte Verkehr",
  DELTA_ERRORS_TOOLTIP_HOW: "Nützlich für RFIDs, Access Points und Geräte mit intrinsischen Datenverlusten.",

  LOG_TOOLTIP_WHAT: "Zählt Alarme und Störungen, fügt sie aber nicht in das Protokoll ein",
  LOG_TOOLTIP_HOW: "Geräte weisen anormale Bedingungen auf, die nicht behoben werden können",

  MONITORING_TOOLTIP_WHAT: "Sendet keine Fragen an das Gerät",
  MONITORING_TOOLTIP_HOW: "Einige Geräte können bei kontinuierlichen Überwachungssystemen ein abnormales Verhalten zeigen und ausfallen.",

  FAULTS_TOOLTIP_WHAT: "Prüft nicht in TS Expert, ob dieses Gerät Fehler hat, sondern protokolliert und zählt weiter in den Registerkarten LiveList und Log",
  FAULTS_TOOLTIP_HOW: "Wird üblicherweise bei Geräten verwendet, die während des Prozesses normale Alarme ausgeben, wie z. B. bei FTS und anderen Geräten, die einen Schnellstart verwenden.",

  ALARMS_TOOLTIP_WHAT: "Überprüft den TS-Experten nicht, ob dieses Gerät Alarme hat, sondern führt die Protokollierung und Abrechnung in den Registerkarten LiveList und Log weiter",
  ALARMS_TOOLTIP_HOW: "Wird üblicherweise bei Geräten verwendet, die während des Prozesses normale Alarme ausgeben, wie z. B. bei FTS und anderen Geräten, die einen Schnellstart verwenden.",

  AVAILABILITY_TOOLTIP_WHAT: "Das Gerät wird bei der Verfügbarkeitsberechnung nicht berücksichtigt",
  AVAILABILITY_TOOLTIP_HOW: "Kann für PROFINET- und Ethernet-Geräte verwendet werden, wobei die Kritikalität des Geräts für den Prozess zu berücksichtigen ist.",

  SNMP_TOOLTIP_WHAT: "Es reduziert das Senden von SNMP-Anfragen an das Gerät erheblich.",
  SNMP_TOOLTIP_HOW_1: "Es gibt Fälle, in denen Geräte mit geringem Durchsatz bei der Beantwortung von SNMP-Anfragen überlastet werden.",
  SNMP_TOOLTIP_HOW_2: "Wenn beim Platzieren von TS Monitor PROFINET im Netzwerk festgestellt wird, dass ein Gerät nicht ordnungsgemäß funktioniert, wird das Hinzufügen zu dieser Blacklist die Rate, mit der SNMP-Anfragen gesendet werden, erheblich reduzieren und das Problem möglicherweise lösen.",

  BLACKLIST_UPDATE_ERROR: "Beim Speichern der Blacklist-Informationen ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
  BLACKLIST_UPDATE_SUCCESS: "Schwarze Liste erfolgreich aktualisiert",

  REQUEST_TOOK_TOO_LONG: "Die Verbindung hat zu lange gebraucht, um zu antworten.\n",
  UNABLE_TO_UPDATE_FOLLOWING_BLACKLISTS: "Die Informationen auf der schwarzen Liste von konnten nicht aktualisiert werden:\n ",
  TRY_AGAIN_STRING: "Bitte versuchen Sie es noch einmal.\nOBS: Die Informationen auf den anderen schwarzen Listen wurden normal aktualisiert",
  ERROR_LIST_DELTA_ERRORS: "- Delta-Fehler; \n",
  ERROR_LIST_LOG: "- Log;\n",
  ERROR_LIST_FAULTS: "- Fehler;\n",
  ERROR_LIST_ALARMS: "- Alarme;\n",
  ERROR_LIST_AVAILABILITY: "-Verfügbarkeit;\n",
  ERROR_LIST_MONITORING: "- Überwachung;\n",
  ERROR_LIST_SNMP: "- SNMP;\n",

  DEVICES_FROM_BLACKLIST_POPUP_1: "Geräte auf der schwarzen Liste der Überwachung erscheinen auf anderen Bildschirmen in schwarzer Farbe",
  DEVICES_FROM_BLACKLIST_POPUP_2: "Geräte aus den anderen Blacklists werden auf anderen Bildschirmen mit ihren Statusfarben angezeigt",
  DEVICES_FROM_BLACKLIST_POPUP_3: "Geräte auf der schwarzen Überwachungsliste erscheinen schwarz",
  DEVICES_FROM_BLACKLIST_POPUP_4: "Geräte aus den anderen Blacklists erscheinen mit ihren normalen Statusfarben",

  // ---------------------------- Edit GSDML page related ----------------------------
  REMOVE_GSDML_SUCCESS: "Die GSDML-Dateien wurden erfolgreich entfernt",
  REMOVE_GSDML_FAILURE: "Beim Entfernen der GSDML-Dateien ist ein Fehler aufgetreten",
  REMOVE_GSDML_FILES: "Verwalten von GSDML-Dateien",
  FILTER_GSDML: "GSDML-Dateien filtern",
  REMOVING_GSDML_FILES: "Entfernen von GSDML-Dateien",

  // ---------------------------- Device Search related ----------------------------
  MANUAL_SEARCH: "Manuelle Suche",
  SEARCH_DEVICES: "Suche nach Geräten",
  MANUAL_SEARCH_TURNED_ON_SUCCESS: "Die manuelle Suche wurde erfolgreich eingeschaltet.",
  MANUAL_SEARCH_TURNED_OFF_SUCCESS: "Die manuelle Suche wurde erfolgreich ausgeschaltet.",
  ERROR_ALTERING_SEARCH_STATE: "Beim Ändern des Suchstatus ist ein Fehler aufgetreten",
  CHOOSE_SEARCH_QUANTITY: "Bitte wählen Sie die Anzahl der durchzuführenden Suchen",
  DEVICE_SEARCH_INIT_SUCCESS: "Die Gerätesuche wurde erfolgreich gestartet.",
  DEVICE_SEARCH_INIT_FAILURE: "Beim Starten der Gerätesuche ist ein Fehler aufgetreten",
  SEARCH: "Suchen",
  SEARCH_NOUN: "Suche",
  SEARCH_MODE: "Suchart",
  MANUAL_SEARCH_TURNED_OFF: "Aus",
  MANUAL_SEARCH_TURNED_ON: "Ein",
  QUANTITY_OF_NEW_SEARCHES: "Anzahl der neuen Suchen",
  ERROR_FETCHING_SEARCH_STATE: "Beim Zugriff auf den Suchstatus ist ein Fehler aufgetreten",

  // ---------------------------- PORTS ----------------------------
  PORTS: "Türen",

  DUPLEX_MODE_1: "Duplex",
  DUPLEX_MODE_2: "Modus",

  INTERFACE_SPEED_1: "Geschwindigkeit",
  INTERFACE_SPEED_2: "der Schnittstelle",

  LINE_DELAY_VALUE_1: "Verzögerung",
  LINE_DELAY_VALUE_2: "Wert",

  ACTIVE: "Aktiv",
  INACTIVE: "Inaktiv",

  // ---------------------------- Ping ----------------------------
  MEDIUM_PING: "Durchschnittlicher Ping",
  LOST_PACKET_PERC_1: "Pings",
  LOST_PACKET_PERC_2: "Verloren (%)",
  TENDENCY: "Tendenz",
  EXPORT_CSV: "XLSX exportieren",
  MISSED_PINGS_POPUP: "Anzahl / % der verlorenen Pings in den letzten 360 durchgeführten Pings",

  // ---------------------------- Ping Graph ----------------------------
  DEVICES_TOOLTIP_1: "Es können maximal 5 Geräte gleichzeitig angezeigt werden",
  DEVICES_TOOLTIP_2: "Geräte mit doppelter IP werden nicht angezeigt, bis das Problem behoben ist",
  TIME_DP: "Zeit: ",
  TIME: "Zeit",
  PING: "Ping",
  PING_GRAPH: "Ping-Grafik",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "WLAN-Adapter",
  WLAN_CONFIG: "WLAN-Einstellungen",
  CONNECTION_STATUS: "Status der Verbindung",

  WLAN_ADAPTER_ON: "Ein",
  WLAN_ADAPTER_OFF: "Aus",

  IP_PLACEHODLER: "192.168.2.215",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Signalstärke",
  FREQUENCY: "Frequenz",
  CHANNEL: "Kanal",
  QUALITY: "Qualität",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2,4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Qualität",

  TURNING_WLAN_OFF_WAITING: "Der WLAN-Adapter wird ausgeschaltet, bitte warten",
  TURNING_WLAN_ON_WAITING: "WLAN-Adapter wird angeschlossen, bitte warten",

  NETWORK: "Netzwerk",
  NETWORK_NAME_1: "Netzwerkname",
  SUBMASK: "Maske",
  GATEWAY: "Gateway",
  DNS: "DNS",
  TAG: "Tag",
  PASSWORD: "Kennwort",
  SETUP: "Konfigurieren",
  YEAR: " Jahr",
  MONTH: " Monat",
  MONTHS: " Monate",
  DAY: " Tag",
  HOUR: " Stunde",
  MINUTE: " Minute",
  SECOND: " Sekunde",

  ALTER_MONITOR_WLAN_CONFIG: "Sind Sie sicher, dass Sie die WLAN-Einstellungen des Monitors ändern möchten?",
  ALTER_OFFICE_INTERFACE_CONFIG_HEADER: "Office-Schnittstelle konfigurieren",
  ALTER_OFFICE_INTERFACE_CONFIG: "Sind Sie sicher, dass Sie die Konfiguration der Office-Schnittstelle ändern möchten?",
  ALTER_OFFICE_INTERFACE_CONFIG_2: "Bei der Nutzung des DHCP-Modus ist darauf zu achten, dass die Office-Schnittstelle nicht im gleichen Subnetz wie die PROFINET-Schnittstelle konfiguriert wird, da sich der TS Monitor PROFINET sonst möglicherweise anders verhält als erwartet.",

  CONNECTED: "Verbunden",
  DISCONNECTED: "Getrennt",

  WLAN_STATUS_POPUP_1: "Zeigt den Status des WLAN-Adapters des Monitors an,",
  WLAN_STATUS_POPUP_2: "Wenn sie ausgeschaltet ist, können die WLAN-Einstellungen nicht geändert werden.",

  CONNECTION_STATUS_POPUP_1: "Zeigt an, ob der Monitor mit dem konfigurierten WLAN-Netzwerk verbunden ist oder nicht.",
  CONNECTION_STATUS_POPUP_1_1: "Zeigt an, ob der Monitor mit dem konfigurierten Ethernet-Netzwerk verbunden ist oder nicht.",

  WLAN_CONFIG_POPUP_1: "Einstellungen können nicht geändert werden, wenn der WLAN-Adapter ausgeschaltet ist.",
  WLAN_CONFIG_POPUP_2: "Es wird dringend empfohlen, die WLAN-Einstellungen nur dann zu ändern, wenn der Zugriff auf den Monitor über das kabelgebundene Netzwerk erfolgt.",
  WLAN_CONFIG_POPUP_3: "Wenn beim Ändern der IP / Maske die Felder nach der Aktualisierung leer erscheinen, ist dies ein deutliches Zeichen dafür, dass:",
  WLAN_CONFIG_POPUP_4: "Es gibt bereits ein anderes Gerät im Netz mit der gleichen IP;",
  WLAN_CONFIG_POPUP_5: "Die Netzmaske ist zu restriktiv und kann die übergebene IP nicht unterstützen",

  WLAN_ADAPTER_NOT_FOUND_1: "Der PROFINET TS Monitor konnte den WLAN-Adapter:\n nicht finden",
  WLAN_ADAPTER_NOT_FOUND_2: "  - Prüfen Sie, ob der Adapter nicht angeschlossen ist oder einen schlechten Kontakt hat",
  WLAN_ADAPTER_NOT_FOUND_3: " - Wenn der Adapter nicht getrennt ist oder keinen schlechten Kontakt hat, versuchen Sie, ihn auszutauschen;\n",
  WLAN_ADAPTER_NOT_FOUND_4: " - Wenn keine der vorherigen Optionen das Problem löst, wenden Sie sich an Toledo e Souza",

  HOSTNAME_POPUP_1: "Ein Hostname muss zwischen 2 und 64 Zeichen lang sein, um gültig zu sein",
  HOSTNAME_POPUP_2: "Darüber hinaus darf er nur Buchstaben, Ziffern, Punkte und Bindestriche enthalten und darf nur mit Buchstaben und Ziffern beginnen und beeden",

  INVALID_HOSTNAME_1: "Der Hostname muss zwischen 2 und 64 Zeichen lang sein",
  INVALID_HOSTNAME_2: "Der Hostname darf nur Buchstaben, Zahlen, Punkte und Bindestriche enthalten und darf nur mit Buchstaben und Zahlen beginnen und enden.",

  HOSTNAME_CONFIG_SUCCESS: "Der Hostname wurde erfolgreich konfiguriert.",
  HOSTNAME_CONFIG_ERROR: "Beim Konfigurieren des Hostnamens ist ein Fehler aufgetreten",
  MODE: "Modus",
  HIDDEN_SSID: "Versteckte SSID",
  OPTIONAL: " (Optional)",
  FIXED_IP: "Feste IP-Adresse",

  // ---------------------------- INVENTORY ----------------------------
  INVENTORY_INPUT_TEXT_PLACEHOLDER: "Filter nach IP, MAC, Name oder Modell",
  MANUFACTURER: "Hersteller",
  ORDER_NUMBER: "Auftragsnummer",
  VERSION_OF: "Version von ",
  IO_CONTROLLER_POPUP_1: "Diese Spalte zeigt an, mit welchen IO-Controllern das Gerät verbunden ist",
  IO_CONTROLLER_POPUP_2: "Es ist möglich, dass das Gerät:",
  IO_CONTROLLER_POPUP_3: "Verbunden mit einem IO-Controller;",
  IO_CONTROLLER_POPUP_4: "Verbunden mit mehr als einem IO-Controller;",
  IO_CONTROLLER_POPUP_5: "Nicht mit einem IO-Controller verbunden",

  DEVICE_COUNTERS_POPUP: "Die Zahlen daneben geben die Gesamtzahlen für jeden Gerätetyp an.",

  NO_IO_CONTROLLER: "Nicht zugeordnet",
  ASSOCIATED: "assoziiert",
  ORDER_NUMBER_N: "Bestellnummer",
  HARDWARE_VERSION_N: "Version der Hardware",
  FIRMWARE_VERSION_N: "Version der Firmware",
  IO_CONTROLLER: "IO-Controller",

  INVENTORY_CSV_HEADER: "Name,MAC,IP,Funktion,Modell,Hersteller,Bestellnummer,Hardware-Version,Firmware-Version,IO-Controller zugeordnet\n",
  INVENTORY_EXPORT_NAME: "Inventar.xlsx",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  CURRENT_VALUE_DP: "Aktueller Wert: ",
  SAVE: "Speichern",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Aktualisierung der TS-Expert-Einstellungen, bitte warten Sie einen Moment.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "Die TS-Expert-Einstellungen wurden erfolgreich gespeichert.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Beim Speichern der TS-Expert-Einstellungen ist ein Fehler aufgetreten.",

  TS_EXPERT_CONFIGURATION: "TS-Experteneinstellungen",

  CONFIG_DIAGNOSTIC_LIST_HEADER: "Alarme",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "Wenn eingeschaltet, protokolliert der TS Expert jedes Mal, wenn ein PROFINET-Gerät Alarme hat. Ein Alarm ist eine Information über einen abnormalen Zustand oder eine Fehlfunktion, die vom IO-Gerät an den IO-Controller gesendet wird und eine Wartung oder sogar einen Austausch erfordert.",

  CONFIG_FAULT_LIST_HEADER: "Fehler",
  CONFIG_FAULT_LIST_CONTENT: "Wenn eingeschaltet, protokolliert der TS-Expert jedes Mal, wenn ein PROFINET-Gerät Fehler aufweist. Dies bedeutet, dass er nicht auf ping- und arp-Befehle im Netzwerk reagiert, d.h. er ist nicht über das Netzwerk erreichbar.",

  CONFIG_DUPLICATE_NAME_LIST_HEADER: "Profiname duplizieren",
  CONFIG_DUPLICATE_NAME_LIST_CONTENT: "Wenn eingeschaltet, protokolliert der TS-Experte jedes Mal, wenn zwei Geräte mit demselben Profinamen konfiguriert werden. Dies kann zu Kommunikationsfehlern führen.",

  CONFIG_DUPLICATE_IP_LIST_CONTENT: "Wenn eingeschaltet, protokolliert TS Expert jedes Mal, wenn eine doppelte IP im Netzwerk entdeckt wird",

  CONFIG_EXCEEDED_PING_LIST_HEADER: "Ping-Zeitüberschreitung",
  CONFIG_EXCEEDED_PING_LIST_CONTENT: "Wenn eingeschaltet, protokolliert TS Expert jedes Mal, wenn der durchschnittliche Ping eines Geräts den Ping-Schwellenwert überschreitet.",

  CONFIG_ERROR_INCREMENT_LIST_HEADER: "Fehlerinkremente",
  CONFIG_ERROR_INCREMENT_LIST_CONTENT: "Wenn diese Option aktiviert ist, protokolliert der TS-Experte jedes Mal, wenn ein Gerät an einem seiner Ports eingehende und/oder ausgehende Fehlerpaketinkremente aufweist.",

  CONFIG_DUPLEX_LIST_HEADER: "Anschluss mit einem nicht empfohlenen Duplex-Modus und/oder einer nicht empfohlenen Geschwindigkeit konfiguriert",
  CONFIG_DUPLEX_LIST_CONTENT: "Wenn eingeschaltet, protokolliert der TS-Experte jedes Mal, wenn sich eine Anschlusskonfiguration von: Vollduplex bei 100 Mbit/s oder Vollduplex bei 1000 Mbit/s (Ports, die auf Halbduplex konfiguriert sind, erzeugen in der Regel Kollisionen und Paketverluste, was für ein Echtzeit-Datenaustausch-und Kontrollprotokoll ein Problem darstellt. Verbindungen, die mit 10 Mbit/s konfiguriert sind, können zu Kommunikationsengpässen werden und die Übertragung von Paketen verhindern)",

  CONFIG_TRAFFIC_EXCEEDED_LIST_HEADER: "Übermäßiger Ein-/Ausgangsverkehr",
  CONFIG_TRAFFIC_EXCEEDED_LIST_CONTENT: "Wenn eingeschaltet, protokolliert der TS-Experte jedes Mal, wenn an einem bestimmten Anschluss ein Gesamtverkehr von mehr als 50 Mbit/s festgestellt wird.",

  CONFIG_INACTIVE_PORT_LIST_HEADER: "Anschluss inaktiviert",
  CONFIG_INACTIVE_PORT_LIST_CONTENT: "Wenn eingeschaltet, protokolliert der TS-Experte jedes Mal, wenn ein aktiver Anschluss deaktiviert wird, entweder durch Trennen oder Unterbrechen eines Kabels oder durch Ausschalten oder Trennen des Geräts am anderen Ende des Kabels. Dies kann auf ein Problem im Kabel, im Stecker, im Gerät am anderen Ende oder sogar in der Elektronik des Geräts selbst hinweisen, bei dem der Anschluss deaktiviert wurde.",

  HW_FW_PORT_LIST_HEADER: "Gleiche Hardware-Version und unterschiedliche Firmware",
  HW_FW_PORT_LIST_CONTENT: "Wenn diese Option aktiviert ist, registriert der TS-Experte jedes Mal, wenn Geräte mit der gleichen Hardware-Version, aber unterschiedlichen Firmware-Versionen erkannt werden. Diese Geräte können unterschiedliche Funktionen, Merkmale und Verhaltensweisen aufweisen. Diese Kennzeichnung soll Querverweise zu Fehlern ermöglichen, die isoliert in dem einen oder anderen Gerät auftreten und mit Firmware-Versionen zusammenhängen können",

  CONFIG_ERROR_CONFIG_LIST_HEADER: "Modul unterscheidet sich von dem konfigurierten",
  CONFIG_ERROR_CONFIG_LIST_CONTENT: "Wenn eingeschaltet, registriert sich der TS Expert jedes Mal, wenn ein anderes als das konfigurierte Modul erkannt wird. Dieser Konfigurationsfehler tritt auf, wenn das in der Konfigurationssoftware angegebene Modul nicht mit dem physisch auf dem IO-Device installierten Modul übereinstimmt.",

  DUPLEX_MISMATCH_CONFIG_LIST_HEADER: "Duplex-Modus stimmt nicht überein",
  DUPLEX_MISMATCH_CONFIG_LIST_CONTENT: "Wenn eingeschaltet, registriert der TS-Experte alle Verbindungen, die mit Duplex-Informationen zurückgegeben wurden und untereinander inkompatibel sind, z. B. ein Halbduplex-Anschluss, der mit einem anderen in Vollduplex verbunden ist.",

  DELAY_EXCEEDED_CONFIG_LIST_HEADER: "Verzögerung",
  DELAY_EXCEEDED_CONFIG_LIST_CONTENT: "Wenn diese Option aktiviert ist, protokolliert der TS-Experte alle Links, die mit Link- oder Kabelverzögerungswerten zurückgekommen sind, die höher sind als die in den PROFINET-Richtlinien empfohlenen Werte.",

  CONFIG_INTERMITTENT_FAILURE_LIST_HEADER: "Intermittierende Fehler",
  CONFIG_INTERMITTENT_FAILURE_LIST_CONTENT: "Wenn eingeschaltet, protokolliert der TS Expert intermittierende Ausfälle von PROFINET-Geräten. Dies zeigt an, dass das Gerät die Kommunikation verliert und sich schnell wieder erholt.",

  CONFIG_LOST_IP_LIST_HEADER: "Verlust der IP-Adresse",
  CONFIG_LOST_IP_LIST_CONTENT: "Wenn diese Option aktiviert ist, protokolliert TS Expert jedes Mal, wenn ein Gerät mit einem möglichen Verlust der IP-Adresse erkannt wird (0.0.0.0).",

  PING_LIMIT: "Ping-Limit",
  ALTER_PING_LIMIT_SUCCESS: "Das Ping-Limit wurde erfolgreich geändert.",
  ALTER_PING_LIMIT_ERROR: "Beim Ändern des Ping-Limits ist ein Fehler aufgetreten.",

  PING_LIMIT_POPUP_1: "Das Ping-Limit ist der durchschnittliche Ping-Wert, bei dessen Überschreitung davon ausgegangen wird, dass ein Problem mit dem Gerät vorliegt. In diesem Fall wird ein Ereignis im TS Expert erstellt",
  PING_LIMIT_POPUP_2: "Jedes Mal, wenn ein Gerät diesen Wert überschreitet, wird ein Ereignis in TS Expert erzeugt.",
  PING_LIMIT_POPUP_3: "Die Einheit der Ping-Messung ist Millisekunden (ms)",
  PING_LIMIT_POPUP_4: "Der minimal zulässige Wert für das Ping-Limit ist 0 ms.",
  PING_LIMIT_POPUP_5: "Der maximal zulässige Wert für das Ping-Limit beträgt 10.000 ms (10 Sekunden).",

  PING_LIMIT_OUT_OF_BOUNDS: "Das Ping-Limit muss zwischen 0 und 10.000 ms (10 Sekunden) liegen.",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_NAME: "Aktionsliste - TS Expert - PROFINET",

  TS_EXPERT_POPUP_1: "Auf dieser Registerkarte werden die TS-Experteninformationen angezeigt",
  TS_EXPERT_POPUP_2: "Dieses Tool ist ein Expertensystem, das entwickelt wurde, um die Analyse der Hauptabweichungen, die von TS Monitor in PROFINET-Netzwerken erkannt werden, zu optimieren und zu beschleunigen",
  TS_EXPERT_POPUP_3: "Auf automatisierte Weise können Wartungs-, Technik- und verwandte Teams eine Liste von Aktionen mit verschiedenen Ereignissen, ihren möglichen Ursachen, Lösungsvorschlägen und den Geräten, in denen sie entdeckt wurden, erhalten.",
  TS_EXPERT_POPUP_4: "Die Verwendung von TS Expert schließt weder die Notwendigkeit menschlicher Analysen aus, noch ersetzt es solche Fähigkeiten, um Datenkorrelationen und Interpretationen zu erstellen.",

  TS_EXPERT: "TS Experte",
  DETECTED_ON: "Erkannt am: ",
  CHECK_YOUR_NETWORK: "Bitte überprüfen Sie Ihr Netzwerk",

  EXPORT_ACTIONS_LIST: "Aktionsliste exportieren",
  GENERATING_ACTIONS_LIST_WAITING: "PDF der Aktionsliste wird generiert, bitte warten",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF erfolgreich generiert. Um sie zu speichern, klicken Sie auf Aktionsliste speichern",

  EVENTS_LIST: "Liste der Ereignisse",
  ACTIONS: "Aktionen",

  NO_PROBLEM_DETECTED: "Der TS-Experte hat keine Ereignisse im Netz festgestellt",
  NO_EVENTS_TO_BE_ANALYZED: "Es gibt keine zu analysierenden Ereignisse",

  NO_EVENT_SELECTED: "Kein Ereignis ausgewählt",
  CHOOSE_AN_EVENT: "Wählen Sie ein Ereignis, um die vorgeschlagenen Aktionen zu sehen",

  DETAILING: "Detaillierung",

  CHECKED: "Geprüft",
  BATCH_CHECK: "Alles prüfen",

  PROBLEM_CHECKED: "Das Ereignis wurde erfolgreich geprüft",
  PROBLEM_CHECK_ERROR: "Bei der Überprüfung des Ereignisses ist ein Fehler aufgetreten",

  QUANTITY_DP: "Menge: ",
  INCREMENTS: "Inkremente",

  PORT_IS_STILL_INACTIVE: "Der Anschluss ist noch inaktiv",
  MARK_PROBLEM_AS_SOLVED: "Sind Sie sicher, dass Sie das Ereignis als geprüft markieren wollen?",

  LAST_UPDATED: "Zuletzt aktualisiert am: ",
  THIS_COMPUTER_TIME: " (Uhrzeit dieses Computers)",

  RECEIVED_INFO: "Informationen erhalten",
  EXPECTED_INFO: "Erwartete Informationen",

  RECEIVED_INFO_DP: "Empfangene Informationen:",
  EXPECTED_INFO_DP: "Erwartete Informationen:",

  MODULE_NUMBER_DP: "Modulname:",
  ALL_EVENTS_WERE_CHECKED: "Alle Ereignisse wurden erfolgreich geprüft",
  CHECK_EVENT_OBS: "\nEs ist wichtig zu beachten, dass die Aktualisierung einiger Daten bis zu 15 Minuten dauert. Es wird daher empfohlen, einige Zeit zu warten, bis diese Liste durch Klicken auf check gelöscht wird.\n",
  ACTIONS_LIST_NAME: "Aktionsliste - TS Expert - PROFINET.pdf",
  SAVE_ACTIONS_LIST: "Liste der Aktionen speichern",
  ACTIONS_LIST: "Aktionsliste",

  UNABLE_TO_CHECK_ALARMS_EVENT: "Ereignis des Geräts kann nicht überprüft werden, da es noch aktive Alarme hat\n",
  UNABLE_TO_CHECK_FAULT_EVENT: "Gerät kann nicht geprüft werden, da es sich noch im Fehlerzustand befindet\n",
  UNABLE_TO_CHECK_DUPLICATE_IP_EVENT: "Gerät kann nicht überprüft werden, da es immer noch eine doppelte IP hat",
  UNABLE_TO_CHECK_DUPLICATE_NAME_EVENT: "Das Geräteereignis konnte nicht überprüft werden, da es immer noch einen doppelten Profilnamen hat\n",
  UNABLE_TO_CHECK_PING_LIMIT_EVENT: "Das Geräteereignis kann nicht überprüft werden, da der durchschnittliche Ping-Wert immer noch über dem konfigurierten Ping-Grenzwert liegt\n",
  UNABLE_TO_CHECK_DELTA_ERROR_EVENT: "Das Geräteereignis kann nicht überprüft werden, da es Ports in Fehlerinkrementen hat\n",
  UNABLE_TO_CHECK_NOT_IN_FULL_DUPLEX_EVENT: "Das Geräteereignis kann nicht überprüft werden, da Ihr Anschluss noch immer in einem nicht empfohlenen Duplex-Modus und/oder mit einer nicht empfohlenen Geschwindigkeit konfiguriert ist\n",
  UNABLE_TO_CHECK_TRAFFIC_EXCESS_EVENT: "Das Geräteereignis konnte nicht überprüft werden, da der Datenverkehr an den folgenden Anschlüssen immer noch 50 Mbit/s überschreitet:\n",
  UNABLE_TO_CHECK_INACTIVE_PORT_EVENT: "Das Geräteereignis konnte nicht geprüft werden, weil sein Anschluss noch inaktiv ist (er war aktiv und wurde dann inaktiv)\n",
  UNABLE_TO_CHECK_HW_FW_EVENT: "Das Ereignis konnte nicht überprüft werden, da die Geräte noch immer dieselben Hardware-Versionen, aber unterschiedliche Firmware-Versionen haben\n",
  UNABLE_TO_CHECK_MODULE_INCOHERENCE_EVENT: "Konnte das Geräteereignis nicht überprüfen, da es noch andere Module hat als in der Konfigurationssoftware deklariert\n",
  UNABLE_TO_CHECK_DUPLEX_MISMATCH_EVENT: "Das Geräteereignis konnte nicht überprüft werden, da der Duplex-Modus nicht übereinstimmt\n",
  UNABLE_TO_CHECK_DELAY_EXCEEDED_EVENT: "Das Geräteereignis konnte nicht geprüft werden, da der Anschluss des Geräts noch immer den Schwellenwert für die Verzögerung überschreitet\n",
  UNABLE_TO_CHECK_INTERMITTENT_FAILURE_EVENT: "Ereignis des Geräts kann nicht geprüft werden, da es intermittierende Fehler aufweist\n",
  UNABLE_TO_CHECK_LOST_IP_EVENT: "Das Geräteereignis kann nicht überprüft werden, da es immer noch einen möglichen Verlust der IP-Adresse anzeigt\n",

  UNABLE_TO_CHECK_ALARMS_EVENTS: "Die Ereignisse der folgenden Geräte können nicht überprüft werden, da sie noch aktive Alarme haben:\n",
  UNABLE_TO_CHECK_FAULT_EVENTS: "Die Ereignisse der folgenden Geräte konnten nicht überprüft werden, da sie sich noch in einem Fehlerzustand befinden:\n",
  UNABLE_TO_CHECK_DUPLICATE_IP_EVENTS: "Die Ereignisse der folgenden Geräte konnten nicht überprüft werden, da es sich immer noch um doppelte IP handelt:\n",
  UNABLE_TO_CHECK_DUPLICATE_NAME_EVENTS: "Die Ereignisse der folgenden Geräte konnten nicht überprüft werden, da sie immer noch einen doppelten Profinamen haben:\n",
  UNABLE_TO_CHECK_PING_LIMIT_EVENTS: "Die Ereignisse der folgenden Geräte können nicht überprüft werden, da die durchschnittlichen Ping-Werte immer noch über dem konfigurierten Ping-Grenzwert liegen:\n",
  UNABLE_TO_CHECK_DELTA_ERROR_EVENTS: "Die Ereignisse der folgenden Geräte konnten nicht überprüft werden, da sie Ports mit Fehlerinkrementen haben:\n",
  UNABLE_TO_CHECK_NOT_IN_FULL_DUPLEX_EVENTS: "Die Ereignisse der folgenden Geräte können nicht überprüft werden, da ihre Ports immer noch in einem nicht empfohlenen Duplex-Modus und/oder mit einer nicht empfohlenen Geschwindigkeit konfiguriert sind:\n",
  UNABLE_TO_CHECK_TRAFFIC_EXCESS_EVENTS: "Die Ereignisse der folgenden Geräte können nicht überprüft werden, da der Datenverkehr an den folgenden Anschlüssen immer noch 50 Mbit/s überschreitet:\n",
  UNABLE_TO_CHECK_INACTIVE_PORT_EVENTS: "Die Ereignisse für die folgenden Geräte konnten nicht überprüft werden, da ihre Ports inaktiv sind (waren aktiv und wurden inaktiv):\n",
  UNABLE_TO_CHECK_HW_FW_EVENTS: "Wir konnten die Ereignisse der folgenden Geräte nicht überprüfen, da sie zwar dieselbe Hardware-Version, aber unterschiedliche Firmware-Versionen haben:\n",
  UNABLE_TO_CHECK_MODULE_INCOHERENCE_EVENTS: "Die Ereignisse der folgenden Geräte konnten nicht überprüft werden, weil sie noch andere Module haben als die in der Konfigurationssoftware deklarierten:\n",
  UNABLE_TO_CHECK_DUPLEX_MISMATCH_EVENTS: "Die Ereignisse für die folgenden Geräte konnten nicht überprüft werden, da sie noch Duplex:\n-Modus-Inkompatibilität aufweisen\n",
  UNABLE_TO_CHECK_DELAY_EXCEEDED_EVENTS: "Die Ereignisse der folgenden Geräte konnten nicht geprüft werden, da ihre Anschlüsse den Verzögerungsgrenzwert noch überschreiten:\n",
  UNABLE_TO_CHECK_INTERMITTENT_FAILURE_EVENTS: "Die Ereignisse der folgenden Geräte konnten nicht überprüft werden, da sie noch intermittierende Fehler aufweisen:\n",
  UNABLE_TO_CHECK_LOST_IP_EVENTS: "Die Ereignisse der folgenden Geräte können nicht überprüft werden, da sie immer noch einen möglichen Verlust der IP-Adresse aufweisen:\n",

  HARDWARE_VERSION: "Hardware-Version",

  // ---------------------------- DIAGNOSTICS ----------------------------
  DIAGNOSTIC_LIST_HEADER: "Es gibt Geräte im Netz, die Alarme haben",
  DEVICE_WITH_DIAGNOSTIC: "Gerät mit Alarm",

  DIAGNOSTIC_SUGGESTION_1: "Wenn ein Gerät Alarme hat, wird vorgeschlagen:",
  DIAGNOSTIC_SUGGESTION_2: "Überprüfen Sie die vom IO Device selbst gesendeten Informationen (die vom TS Monitor erkannt und in Text umgewandelt werden) und versuchen Sie, das Problem zu lösen. Wenn Sie Schwierigkeiten haben, die Diagnose zu verstehen, wenden Sie sich an den Hersteller des Geräts oder sehen Sie im Handbuch des IO-Geräts nach, um Ihre Zweifel vor einem Eingriff auszuräumen.",

  NO_DEVICE_WITH_DIAGNOSTIC: "Es gibt keine Geräte im Netz mit aktiven Alarmen",

  // ---------------------------- FAULTS ----------------------------
  FAULTS_LIST_HEADER: "Es gibt Geräte im Netz, die Fehler haben",
  DEVICE_WITH_FAULT: "Gerät defekt",

  FAULT_SUGGESTION_1: "Wenn ein Gerät Fehler hat, wird vorgeschlagen:",
  FAULT_SUGGESTION_2: "Stromversorgung des IO-Geräts prüfen;",
  FAULT_SUGGESTION_3: "Überprüfen Sie, ob das Gerät physisch mit dem Netz verbunden ist;",
  FAULT_SUGGESTION_4: "Prüfen Sie die Unversehrtheit des Steckers;",
  FAULT_SUGGESTION_5: "Kabelintegrität prüfen;",
  FAULT_SUGGESTION_6: "Überprüfen Sie, ob das Gerät seine IP-Adresse verloren hat. Wenn dies der Fall ist, erscheint es auf dem Monitor mit der IP: 0.0.0.0.0, außerdem wird seine IP in der Live-Liste orange markiert.",

  NO_DEVICE_WITH_FAULT: "Im Netz gibt es keine Geräte mit Fehlern",

  // ---------------------------- DUPLICATE IP ----------------------------
  DUPLICATE_IP_LIST_HEADER: "Es gibt Geräte im Netzwerk mit doppelter IP",
  DEVICES_WITH_DUPLICATE_IP: "Geräte mit doppelter IP",

  DUPLICATE_IP_CARD_DESC: "Die folgenden Geräte verwenden eine IP-Adresse: ",

  DUPLICATE_IP_SUGGESTION_1: "Wenn doppelte IPs im Netz vorhanden sind, wird vorgeschlagen:",
  DUPLICATE_IP_SUGGESTION_2: "Überprüfen Sie die physikalischen Adressen, MAC, um Geräte zu identifizieren, die einen IP-Adressenkonflikt haben und korrigieren Sie die Einstellungen dieser Adresse.",

  NO_DEVICES_WITH_DUPLICATE_IPS: "Es gibt keine Geräte im Netz mit doppelten IPs",

  // ---------------------------- DUPLICATE NAME ----------------------------
  DUPLICATE_NAME_LIST_HEADER: "Es gibt Geräte im Netzwerk mit doppeltem Profinamen.",
  DEVICES_WITH_DUPLICATE_NAME: "Geräte mit doppeltem Profinamen",

  DUPLICATE_NAME_CARD_DESC: "Die folgenden Geräte verwenden den Namen: ",

  DUPLICATE_NAME_SUGGESTION_1: "Wenn es im Netz Geräte mit doppeltem Profilnamen gibt, wird vorgeschlagen:",
  DUPLICATE_NAME_SUGGESTION_2: "Überprüfen Sie das Projekt und ändern Sie das IO-Gerät, das den falschen Profilnamen hat",

  NO_DEVICES_WITH_DUPLICATE_NAMES: "Es gibt keine Geräte im Netzwerk mit doppeltem Namen",

  // ---------------------------- PING LIMIT ----------------------------
  GROUP_PING_LIMIT_HEADER: "Es gibt Geräte im Netz, die den Ping-Schwellenwert überschritten haben.",
  PING_LIMIT_EXCEEDED: "Ping-Limit überschritten",

  REGISTERED_PING: "Ping registriert: ",

  PING_LIMIT_SUGGESTION_1: "Wenn ein Gerät den Ping-Schwellenwert überschreitet, wird vorgeschlagen:",
  PING_LIMIT_SUGGESTION_2: "Verkehrsprobleme:",
  PING_LIMIT_SUGGESTION_3: "Verwenden Sie die Registerkarte Verkehr und überprüfen Sie die Anwendungen, die die Verbindung nutzen, um festzustellen, ob sie mit der verfügbaren Infrastruktur übereinstimmen",
  PING_LIMIT_SUGGESTION_4: "Prüfen Sie, ob die verfügbare Bandbreite der Anwendung entspricht (Verwendung von Fast- oder Gigabit-Ethernet-Switches).",

  PING_LIMIT_SUGGESTION_5: "Hoher Einsatz von Geräten und Schaltern bei der Verarbeitung:",
  PING_LIMIT_SUGGESTION_6: "Überprüfung des Datenverbrauchs der Anwendung;",
  PING_LIMIT_SUGGESTION_7: "Prüfen Sie die Temperatur der Ausrüstung",

  PING_LIMIT_SUGGESTION_8: "Ausbreitungsverzögerung (übermäßige Kabellänge):",
  PING_LIMIT_SUGGESTION_9: "Ermitteln Sie die Kabellänge visuell, wenn sie auf dem Kabel eingraviert ist, oder mit Hilfe von Prüfgeräten oder Zertifizierern.",

  NO_DEVICE_EXCEEDED_PING_LIMIT: "Es gibt keine Geräte im Netz, die den Ping-Grenzwert überschritten haben",

  // ---------------------------- DELTA FEHLER ----------------------------
  DELTA_ERROR_LIST_HEADER: "Es gibt Geräte im Netzwerk mit Ports, die Fehlerinkremente aufweisen.",
  DELTA_ERROR_ALARM: "Fehlerinkremente",
  DEVICE_HAS_DELTA_ERROR_PROBLEMS: "Das Gerät hat Fehlerinkremente an den folgenden Anschlüssen:",

  DELTA_ERRORS_SUGGESTION_1: "Wenn ein Gerät über Anschlüsse verfügt, die Fehlerinkremente aufweisen, wird Folgendes vorgeschlagen:",
  DELTA_ERRORS_SUGGESTION_2: "Eingabefehler",
  DELTA_ERRORS_SUGGESTION_3: "Prüfen Sie auf Duplex-Fehlanpassung (ein 100-Mbit/s-Vollduplex-Anschluss ist mit einem 10-Mbit/s-Halbduplex-Anschluss verbunden). Die Verbindungen sollten an beiden Enden die gleiche Konfiguration haben und vorzugsweise Autonegotiation verwenden",
  DELTA_ERRORS_SUGGESTION_4: "Prüfen Sie, ob die Datenkabel in Schächten, Kanälen und Rohren in der Nähe von Stromkabeln, Laufwerken und anderen Geräten mit hohem Stromverbrauch verlegt sind, deren Verkabelung Störungen verursachen kann. Die Netzkabel sollten so weit wie möglich entfernt oder in isolierten und geerdeten Rohren verlegt werden;",
  DELTA_ERRORS_SUGGESTION_5: "Überprüfen Sie die Qualität der Ethernet-Verbindungen. Schlecht konfektionierte Stecker, minderwertige Kabel und Steckverbinder können Verluste verursachen;",
  DELTA_ERRORS_SUGGESTION_6: "Prüfen Sie mit Hilfe eines Zertifizierers, ob die Kabel intakt und für die jeweilige Kategorie (Cat5, Cat5e, Cat6 usw.) geeignet sind",
  DELTA_ERRORS_SUGGESTION_7: "Ausgabefehler",
  DELTA_ERRORS_SUGGESTION_8: "Prüfen Sie auf Duplex-Fehlanpassung (ein 100-Mbit/s-Vollduplex-Anschluss ist mit einem 10-Mbit/s-Halbduplex-Anschluss verbunden). Die Verbindungen sollten an beiden Enden die gleiche Konfiguration haben und vorzugsweise Autonegotiation verwenden",
  DELTA_ERRORS_SUGGESTION_9: "Überprüfen Sie die Qualität der Ethernet-Verbindungen. Schlecht konfektionierte Stecker, minderwertige Kabel und Steckverbinder können Verluste verursachen;",
  DELTA_ERRORS_SUGGESTION_10: "Überprüfen Sie die Netzwerkschnittstelle des Geräts auf mögliche Probleme und tauschen Sie sie gegebenenfalls aus.",

  DEVS_WITH_DELTA_ERRORS_EXPLANATION_1: "In dieser Liste sind nur Geräte und ihre Anschlüsse aufgeführt, die Eingangs- oder Ausgangsfehlerinkremente aufweisen.",
  DEVS_WITH_DELTA_ERRORS_EXPLANATION_2: "Fehlerzähler, die ein Inkrement haben, werden orange hervorgehoben",

  NO_DEVICE_WITH_DELTA_ERRORS_LIMIT: "Es gibt keine Geräte im Netz mit Anschlüssen, die Fehlerinkremente aufweisen",

  // ---------------------------- NICHT IN VOLLDUPLEX ----------------------------
  NOT_IN_FULL_DUPLEX_LIST_HEADER: "Es gibt Geräte im Netzwerk, deren Ports in einem Duplex-Modus und/oder mit einer Geschwindigkeit konfiguriert sind, die nicht empfohlen werden.",
  PORT_NOT_IN_FULL_DUPLEX: "Anschluss in einem nicht empfohlenen Duplex-Modus und/oder mit einer nicht empfohlenen Geschwindigkeit konfiguriert",

  DUPLEX_MODE: "Duplex-Modus",

  NOT_IN_FULL_DUPLEX_SUGGESTION_1: "Wenn ein Anschluss in einem nicht empfohlenen Duplex-Modus und/oder mit einer nicht empfohlenen Geschwindigkeit konfiguriert ist, wird Folgendes vorgeschlagen:",
  NOT_IN_FULL_DUPLEX_SUGGESTION_2: "Überprüfen Sie, ob die Ports die Autonegotiation-Funktion aktiviert haben. Wenn sie eingestellt ist, wird empfohlen, die Baudrate auf mindestens 100Mb und den Duplex-Modus auf Vollduplex zu ändern",
  NOT_IN_FULL_DUPLEX_SUGGESTION_3: "Wenn die Auto-Negotiation-Option aktiviert ist und die Verbindung immer noch im Halbduplex-Modus ist, empfehlen wir, die Verkabelung zu ändern, und wenn diese Option nicht zur Vollduplex-Verhandlung führt, können die Netzwerkschnittstellen geändert werden",

  NO_DEVICES_WITHOUT_FULL_DUPLEX: "Es gibt keine Geräte im Netzwerk mit Anschlüssen, die in einem nicht empfohlenen Duplex-Modus und/oder mit einer nicht empfohlenen Geschwindigkeit konfiguriert sind",

  // ---------------------------- VERKEHRSÜBERSCHREITUNG ----------------------------
  TRAFFIC_EXCESS_LIST_HEADER: "Es gibt Geräte im Netzwerk mit Anschlüssen, die mehr als 50 Mbit/s Datenverkehr aufweisen",
  TRAFFIC_EXCESS: "Der Datenverkehr hat 50 Mbps überschritten",
  DEVICE_HAS_TRAFFIC_EXCESS_ERROR_PROBLEMS: "Das Gerät hat den Datenverkehr von 50 Mbps an den folgenden Anschlüssen überschritten:",

  TRAFFIC_EXCESS_SUGGESTION_1: "Wenn ein Gerät Anschlüsse hat, die mehr als 50 Mbit/s eingehenden oder ausgehenden Datenverkehr aufweisen:",
  TRAFFIC_EXCESS_SUGGESTION_2: "Die PROFINET-Richtlinien geben an, dass ein Verkehrsaufkommen von bis zu 20 % (oder 20 Mbps auf 100-Mb-Links) akzeptabel ist, dass das Verkehrsaufkommen zwischen 20 und 50 % überprüft werden muss und dass bei einem Verkehrsaufkommen von über 50 % sofortige Maßnahmen erforderlich sind. Bei einem Verkehrsaufkommen von mehr als 50 Mbps wird Folgendes empfohlen:",
  TRAFFIC_EXCESS_SUGGESTION_3: "Prüfen Sie, ob es möglich ist, die Reaktionszeit von IO-Geräten zu verlängern (unter Berücksichtigung von Prozesszeiten, Sicherheit usw.);",
  TRAFFIC_EXCESS_SUGGESTION_4: "Aufteilung der Geräte in verschiedene Subnetze und Steuerungen;",
  TRAFFIC_EXCESS_SUGGESTION_5: "Analysieren Sie die Topologie und prüfen Sie die Möglichkeit, neue Pfade für einen bestimmten höheren Datenverkehr zu schaffen, z. B. durch Hinzufügen von Switches;",
  TRAFFIC_EXCESS_SUGGESTION_6: "Überprüfen Sie den Ursprung dieses Datenverkehrs und ob es notwendig ist, dass dieses Gerät im PROFINET-Netz kommuniziert (isolieren Sie die Geräte, die die Steuerung durchführen, von anderen, die für die Wartung, Datenerfassung oder andere Aufgaben verwendet werden, die nicht in Echtzeit ablaufen)",

  DEVS_WITH_TRAFFIC_EXCESS_EXPLANATION_1: "In dieser Liste werden nur Geräte und ihre Anschlüsse angezeigt, deren eingehender oder ausgehender Datenverkehr 50 Mbps übersteigt.",
  DEVS_WITH_TRAFFIC_EXCESS_EXPLANATION_2: "Datenverkehr, der 50 Mbps überschreitet, wird orange hervorgehoben.",

  NO_DEVICE_WITH_TRAFFIC_EXCESS: "Es gibt keine Geräte im Netzwerk mit Anschlüssen, die mehr als 50 Mbit/s Datenverkehr aufweisen.",

  INPUT_TRAFFIC_KBPS: "Eingehender Verkehr (Kbps)",
  OUTPUT_TRAFFIC_KBPS: "Eingehender Verkehr (Kbps)",

  // ---------------------------- INAKTIVER ANSCHLUSS ----------------------------
  INACTIVE_PORT_LIST_HEADER: "Es gibt Geräte im Netzwerk, deren Ports inaktiviert wurden.",
  INACTIVE_PORT: "Anschluss inaktiviert",

  INACTIVE_PORT_SUGGESTION_1: "Wenn ein Anschluss inaktiviert wird (war aktiv und wurde inaktiv)\vorgeschlagen:",
  INACTIVE_PORT_SUGGESTION_2: "Überprüfen Sie Kabel und Stecker (an beiden Enden), die Stromversorgung des am anderen Ende angeschlossenen Geräts und den Kabelbruch. Im letzteren Fall wird der Austausch des Moduls empfohlen",

  NO_DEVICES_WITH_INACTIVE_PORTS: "Es gibt keine Geräte im Netz, die inaktive Ports haben (es war aktiv und wurde inaktiv)",

  // ---------------------------- HARDWARE / FIRMWARE ----------------------------
  HW_FW_LIST_HEADER: "Es gibt Geräte im Netz mit denselben Hardware-Versionen, aber unterschiedlichen Firmware-Versionen",
  HW_FW: "Gleiche Hardware-Versionen und unterschiedliche Firmware",
  SAME_HW_DIFF_FW: "Die folgenden Geräte haben die gleiche Hardware-Version, aber unterschiedliche Firmware-Versionen",
  FIRMWARE: "Firmware",

  HW_FW_SUGGESTION_1: "Wenn zwei Geräte die gleiche Hardware-Version, aber unterschiedliche Firmware-Versionen haben, wird vorgeschlagen:",
  HW_FW_SUGGESTION_2: "Aktualisieren Sie die Firmware dieser Geräte, so dass sie alle gleich aussehen, um die Stabilität des Netzes und die Funktionalitäten der Geräte zu erhalten",
  HW_FW_SUGGESTION_3: "Es ist sehr wichtig, diesen Vorgang außerhalb der Produktion durchzuführen und den Gerätehersteller zu konsultieren, bevor Sie mit dieser Aufgabe beginnen, um Inkompatibilität und Betriebsprobleme zu vermeiden.",

  NO_DIFF_HW_FW: "Es gibt keine Geräte im Netz mit identischen Hardware-Versionen, aber unterschiedlichen Firmware-Versionen.",

  // ---------------------------- MODUL INKOHÄRENZ ----------------------------
  MODULE_INCOHERENCE_LIST_HEADER: "Es gibt Geräte im Netz mit anderen als den in der Konfigurationssoftware deklarierten Modulen.",
  MODULE_INCOHERENCE: "Ein anderes Modul als das in der Konfigurationssoftware angegebene",
  INCOHERENCE_IN_MODULE: "Abweichung im folgenden Modul festgestellt",

  MODULE_INCOHERENCE_SUGGESTION_1: "Wenn das Gerät über andere als die in der Konfigurationssoftware angegebenen Module verfügt, wird Folgendes empfohlen:",
  MODULE_INCOHERENCE_SUGGESTION_2: "Überprüfen Sie die Konfiguration und Installation, um die vom Gerät gemeldete Abweichung zu beheben",

  NO_DIFF_MODULES: "Im Netz gibt es keine Geräte mit anderen als den in der Konfigurationssoftware angegebenen Modulen",
  MODULE: "Modul",

  // ---------------------------- DUPLEX-FEHLANPASSUNG ----------------------------
  DUPLEX_MISMATCH_LIST_HEADER: "Es gibt Geräte im Netzwerk mit Duplex-Modus-Inkompatibilität.",
  DUPLEX_MISMATCH: "Inkompatibilität des Duplex-Modus",

  DUPLEX_MISMATCH_SUGGESTION_1: "Wenn zwei Geräte im Duplex-Modus inkompatibel sind, wird Folgendes empfohlen:",
  DUPLEX_MISMATCH_SUGGESTION_2: "Überprüfen Sie die Konfiguration der Ports an beiden Enden, um festzustellen, ob sie sich im Autonegotiation- oder im erzwungenen Duplex-Modus befinden;",
  DUPLEX_MISMATCH_SUGGESTION_3: "Falls beide Ports im Autonegotiation-Modus sind, wird empfohlen, die Integrität der Verkabelung zu testen;",
  DUPLEX_MISMATCH_SUGGESTION_4: "Als letztes Mittel sollte die Netzwerkschnittstelle des Geräts ausgetauscht werden",

  NO_DEVICES_WITH_DUPLEX_MISMATCH: "Es gibt keine Geräte im Netzwerk mit Duplex-Modus-Inkompatibilität.",

  // ---------------------------- VERZÖGERUNG ÜBERSCHRITTEN ----------------------------
  DELAY_EXCEEDED_LIST_HEADER: "Es gibt Geräte im Netzwerk mit Verzögerungsänderung.",
  DELAY_EXCEEDED: "Verzögerungsänderung",

  DELAY_EXCEEDED_SUGGESTION_1: "Wenn ein Gerät eine Verzögerungsänderung hat, wird vorgeschlagen:",
  DELAY_EXCEEDED_SUGGESTION_2: "Im Falle einer veränderten Kabelverzögerung empfehlen wir, das physische Medium zu überprüfen, die Verbindungen zu zertifizieren, die Kabellänge zu überprüfen (sie kann durch die auf dem Kabel eingravierte Nummerierung der Länge identifiziert werden), die ordnungsgemäße Montage der Steckverbinder sowie die Qualität und Kategorie (mindestens Cat5) der in dieser Infrastruktur verwendeten Elemente;",
  DELAY_EXCEEDED_SUGGESTION_3: "Für den Fall einer geänderten Leitungsverzögerung gilt derselbe Vorschlag wie oben, und falls dies nicht zum Erfolg führt, schlagen wir vor, die Netzwerkschnittstellen auszutauschen, da dieser Parameter die Zeiten nicht nur im Kabel, sondern auch im Empfänger und im Sender zusammen angibt;",

  // ---------------------------- INTERMITTIERENDE STÖRUNGEN ----------------------------
  INTERMITTENT_FAILURES_LIST_HEADER: "Es gibt Geräte im Netz, die intermittierende Fehler aufweisen.",
  DEVICE_WITH_INTERMITTENT_FAILURE: "Gerät mit intermittierendem Fehler",

  INTERMITTENT_FAILURES_SUGGESTION_1: "Wenn ein Gerät intermittierende Fehler aufweist, wird vorgeschlagen:",
  INTERMITTENT_FAILURES_SUGGESTION_2: "Stromversorgung des IO-Geräts überprüfen;",
  INTERMITTENT_FAILURES_SUGGESTION_3: "Prüfen Sie die Unversehrtheit des Steckers;",
  INTERMITTENT_FAILURES_SUGGESTION_4: "Überprüfen Sie die Integrität des Kabels",

  NO_DEVICE_WITH_INTERMITTENT_FAILURE: "Im Netz gibt es keine Geräte mit intermittierenden Fehlern",

  // ---------------------------- LOST IP ----------------------------
  LOST_IP_LIST_HEADER: "Es gibt Geräte im Netzwerk mit einem möglichen Verlust der IP-Adresse.",
  LOST_IP_DESCR: "Bitte überprüfen Sie Ihr Netzwerk.",
  DEVICE_WITH_LOST_IP: "Gerät mit möglichem Verlust der IP-Adresse",

  LOST_IP_SUGGESTION_1: "Wenn bei einem Gerät ein möglicher IP-Verlust auftritt, wird Folgendes empfohlen:",
  LOST_IP_SUGGESTION_2: "Überprüfen Sie die physikalischen Adressen, MAC, um Geräte zu identifizieren, die einen IP-Adressenkonflikt haben und korrigieren Sie die Einstellungen dieser Adresse.",

  // ---------------------------- EXPERT REPORT ----------------------------
  DIAGNOSTIC_PAGE_TITLE: ". - Gerät mit Alarm",
  FAULT_PAGE_TITLE: ". - Fehlerhaftes Gerät",
  DUPLICATE_IP_PAGE_TITLE: ". - Geräte mit doppelter IP",
  DUPLICATE_NAME_PAGE_TITLE: ". - Geräte mit doppeltem Profinamen",
  PING_LIMIT_EXCEEDED_PAGE_TITLE: ". - Ping-Limit überschritten",
  DELTA_ERROR_ALARM_PAGE_TITLE: ". - Fehlerinkremente",
  PORT_NOT_IN_FULL_DUPLEX_PAGE_TITLE: ". Anschluss, der in einem nicht empfohlenen Duplex-Modus und/oder mit einer nicht empfohlenen Geschwindigkeit konfiguriert ist",
  TRAFFIC_EXCESS_PAGE_TITLE: ". Datenverkehr hat 50 Mbps überschritten",
  INACTIVE_PORT_PAGE_TITLE: ". - Inaktivierter Anschluss",
  HW_FW_TITLE: ". - Gleiche Hardware-Versionen und unterschiedliche Firmware",
  MODULE_INCOHERENCE_TITLE: ". - Modul, das sich von dem in der Konfigurationssoftware angegebenen Modul unterscheidet",
  DUPLEX_MISMATCH_PAGE_TITLE: ". - Inkompatibilität des Duplex-Modus",
  DELAY_EXCEEDED_PAGE_TITLE: ". - Verzögerung ändern",
  INTERMITTENT_FAILURE_PAGE_TITLE: ". - intermittierendes fehlerhaftes Gerät",
  LOST_IP_PAGE_TITLE: ". - Gerät mit möglichem Verlust der IP-Adresse",

  PORTUGUESE: "Portugiesisch",
  ENGLISH: "Englisch",
  SPANISH: "Spanisch",
  GERMAN: "Deutsch",
  UPDATING_LANGUAGE_WAITING: "Ändern der Sprache, bitte warten Sie einen Moment",
  UNABLE_TO_ALTER_LANGUAGE: "Die Programmsprache konnte nicht geändert werden.\n",

  // ---------------------------- EXPERT REPORT ----------------------------
  DEVICE_WITH_DIAGNOSTIC_DOTS: ".........................................................................................................................",
  DEVICE_WITH_FAULT_DOTS: "...............................................................................................................................",
  DEVICES_WITH_DUPLICATE_IP_DOTS: ".............................................................................................................",
  DEVICES_WITH_DUPLICATE_NAME_DOTS: "...........................................................................................",
  PING_LIMIT_EXCEEDED_DOTS: "............................................................................................................",
  DELTA_ERROR_ALARM_DOTS: ".......................................................................................................................",
  PORT_NOT_IN_FULL_DUPLEX_DOTS: "........................................................................................................",
  TRAFFIC_EXCESS_DOTS: "..........................................................................",
  INACTIVE_PORT_DOTS: "..................................................................................................................",
  HW_FW_DOTS: "...............................................",
  HW_FW_DOTS_2: "................................................",
  MODULE_INCOHERENCE_DOTS: "...............................",
  MODULE_INCOHERENCE_DOTS_2: "................................",
  DUPLEX_MISMATCH_DOTS: ".........................................................................................",
  DUPLEX_MISMATCH_DOTS_2: "..........................................................................................",

  DELAY_EXCEEDED_DOTS: ".............................................................................................................",
  DELAY_EXCEEDED_DOTS_2: ".............................................................................................................",

  DEVICE_WITH_INTERMITTENT_FAILURE_DOTS: "...........................................................................................",
  DEVICE_WITH_INTERMITTENT_FAILURE_DOTS_2: "...........................................................................................",

  DEVICE_WITH_LOST_IP_DOTS: "...........................................................................",

  DISCLAIMER_EXPERT_DOTS: "....................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: "....................................................................................................................",

  OVERVIEW_DOTS: "....................................................................................................................................",
  LIVE_LIST_DOTS: "....................................................................................................................................",
  INVENTORY_DOTS: "........................................................................................................................................",
  TOPOLOGY_DOTS: "....................................................................................................................................",
  IN_TRAFFIC_ERRORS_DOTS: ".................................................................................................",
  OUT_TRAFFIC_ERRORS_DOTS: "................................................................................................",
  MON_LOG_DOTS: "...............................................................................................................................................",
  DISCLAIMER_DOTS: "....................................................................................................................",
  DISCLAIMER_DOTS_2: ".....................................................................................................................................",

  ADD_ALTER_TAGS: "Tags hinzufügen/ändern",
  CHANGE_TAG_FAILURE: "Beim Ändern des Tags ist ein Fehler aufgetreten",
  CHANGE_TAG_SUCCESS: "Das Tag wurde erfolgreich geändert.",
  CHOOSE_DEVICE: "Gerät auswählen",
  CONFIRM_REMOVE_ALL_TAGS: "Möchten Sie wirklich die Tags aller Geräte entfernen?",
  EXPORT_TAGS: "Tags exportieren",
  IMPORT_TAGS: "Tags importieren",
  IMPORT_TAGS_FAILURE: "Fehler beim Importieren der Tags: ",
  IMPORT_TAGS_SUCCESS: "Tags wurden erfolgreich importiert",
  NEW_TAG: "Neues Tag",
  N_REASON_DP: "\\nGrund: ",
  PLEASE_SELECT_DEVICE: "Bitte wählen Sie ein Gerät aus.",
  PLEASE_SELECT_TAG_FILE: "Bitte wählen Sie eine Tag-Datei aus.",
  REMOVE: "Entfernen",
  REMOVE_ALL_TAGS: "Alle Tags entfernen",
  REMOVE_TAG_FAILURE: "Fehler beim Entfernen der Tags",
  REMOVE_TAG_SUCCESS: "Tags wurden erfolgreich entfernt.",
  TAGS: "Geräte-Tags",
  ACTIVE_COLUMNS: "Aktive Spalten",

  // PRO-Topologiekompatibilität
  ACCESS_POINT: "Access Point",
  ADD: "Hinzufügen",
  ADD_DEVICE: "Gerät hinzufügen",
  ALERT_AUTO_DETECTED_CONNECTIONS_CANNOT_BE_REMOVED: "Automatisch erkannte Verbindungen können nicht entfernt werden.",
  ALERT_CHOOSE_DEVICE_TYPE: "Bitte wählen Sie einen Gerätetyp aus.",
  ALERT_MANUAL_CONNECTION_CREATION_FAILED: "Die manuelle Verbindung konnte nicht erstellt werden.",
  ALERT_ONLY_MANUAL_CONNECTIONS_CAN_BE_REMOVED: "Nur manuell erstellte Verbindungen können entfernt werden.",
  ALERT_ONLY_MANUAL_DEVICES_CAN_BE_EDITED: "Nur manuell hinzugefügte Geräte können bearbeitet werden.",
  ALERT_ONLY_MANUAL_DEVICES_CAN_BE_REMOVED: "Nur manuell hinzugefügte Geräte können entfernt werden.",
  ALERT_SELECT_DIFFERENT_DEVICES_FOR_CONNECTION: "Wählen Sie zwei verschiedene Geräte aus, um eine Verbindung zu erstellen.",
  CANCEL: "Abbrechen",
  CHOOSE_A_DEVICE: "Wählen Sie ein Gerät aus, um dessen Informationen anzuzeigen.",
  CURRENT_JITTER: "Aktueller Jitter",
  CURRENT_PING: "Aktueller Ping",
  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Gerätetyp auswählen",
  ENDPOINT: "Endgerät",
  EXPORT_SVG_POPUP_MSG_1: "Um das Topologiebild im SVG-Format zu exportieren, muss zunächst die Topologieposition gespeichert werden.",
  EXPORT_SVG_POPUP_MSG_2: "Um das Topologiebild im SVG-Format zu exportieren, muss zunächst die Topologieposition gespeichert werden, wie in der folgenden Abbildung dargestellt:",
  EXPORT_SVG_POPUP_MSG_3: "Stellen Sie vor dem Klicken auf die SVG-Schaltfläche sicher, dass alle Netzwerkgeräte innerhalb des Rechtecks angezeigt werden, wie in der folgenden Abbildung dargestellt:",
  EXPORT_SVG_POPUP_MSG_4: "Wenn sich ein Gerät außerhalb des sichtbaren Bereichs befindet, wie in der folgenden Abbildung dargestellt, wird es nicht in der SVG-Datei angezeigt:",
  FIREWALL: "Firewall",
  GRAPHIC_TOPOLOGY_ADD_REGION: "Bereich hinzufügen",
  GRAPHIC_TOPOLOGY_CANCEL_REGION_DRAWING: "Zeichnen abbrechen",
  GRAPHIC_TOPOLOGY_DEFAULT_REGION_NAME: "Anlage",
  GRAPHIC_TOPOLOGY_DEVICES: "Geräte",
  GRAPHIC_TOPOLOGY_DEVICES_LOWERCASE: "Geräte",
  GRAPHIC_TOPOLOGY_DEVICE_TAB: "Gerät",
  GRAPHIC_TOPOLOGY_DISPLAY_CONFIG_SAVED: "Die Anzeigeeinstellungen wurden erfolgreich gespeichert.",
  GRAPHIC_TOPOLOGY_DISPLAY_CONFIG_SAVE_ERROR: "Die Anzeigeeinstellungen konnten nicht gespeichert werden.",
  GRAPHIC_TOPOLOGY_DISPLAY_HELP: "Wählen Sie aus, welche Informationen unter automatisch erkannten Geräten angezeigt werden.",
  GRAPHIC_TOPOLOGY_DISPLAY_TAB: "Anzeige",
  GRAPHIC_TOPOLOGY_DRAW_REGION_INSTRUCTION: "Klicken und ziehen Sie in der Topologie, um den Bereich zu zeichnen. Lassen Sie die Maustaste los, um seinen Namen einzugeben.",
  GRAPHIC_TOPOLOGY_EDIT_REGION: "Bereich bearbeiten",
  GRAPHIC_TOPOLOGY_FILES_HELP: "Exportieren Sie die Topologie oder importieren Sie eine zuvor gespeicherte JSON-Datei.",
  GRAPHIC_TOPOLOGY_FILES_TAB: "Dateien",
  GRAPHIC_TOPOLOGY_MANUAL_CONNECTION: "Manuelle Verbindung",
  GRAPHIC_TOPOLOGY_MANUAL_DEVICES: "Hinzugefügt",
  GRAPHIC_TOPOLOGY_NEW_REGION: "Neuer Bereich",
  GRAPHIC_TOPOLOGY_POSITION_HELP: "Bearbeiten, speichern oder entfernen Sie die aktuellen Geräte- und Bereichspositionen.",
  GRAPHIC_TOPOLOGY_POSITION_TAB: "Position",
  GRAPHIC_TOPOLOGY_REGIONS: "Bereiche",
  GRAPHIC_TOPOLOGY_REGIONS_HELP: "Erstellen Sie Anlagenbereiche und passen Sie jeden Bereich direkt auf der Zeichenfläche an.",
  GRAPHIC_TOPOLOGY_REGIONS_LOWERCASE: "Bereiche",
  GRAPHIC_TOPOLOGY_REGIONS_TAB: "Bereiche",
  GRAPHIC_TOPOLOGY_REGION_NAME: "Bereichsname",
  GRAPHIC_TOPOLOGY_REGION_NAME_PLACEHOLDER: "Beispiel: Anlage-1",
  GRAPHIC_TOPOLOGY_REGION_NAME_REQUIRED: "Geben Sie den Bereichsnamen ein.",
  GRAPHIC_TOPOLOGY_REMOVE_REGION: "Bereich entfernen",
  GRAPHIC_TOPOLOGY_SEARCH_EMPTY: "Geben Sie eine IP-Adresse, ein Tag oder einen PROFINET-Namen für die Suche ein.",
  GRAPHIC_TOPOLOGY_SEARCH_NOT_FOUND_1: "Kein Gerät gefunden für: ",
  GRAPHIC_TOPOLOGY_SEARCH_NOT_FOUND_2: ".",
  GRAPHIC_TOPOLOGY_SELECTED_REGION_PLACEHOLDER: "Ausgewählter Bereich",
  GRAPHIC_TOPOLOGY_SELECT_REGION_TO_EDIT: "Wählen Sie einen Bereich zum Bearbeiten aus.",
  GRAPHIC_TOPOLOGY_SELECT_REGION_TO_REMOVE: "Wählen Sie einen Bereich zum Entfernen aus.",
  GRAPHIC_TOPOLOGY_SHOW_IP: "IP-Adresse anzeigen",
  GRAPHIC_TOPOLOGY_SHOW_PROFINAME: "PROFINET-Namen anzeigen",
  GRAPHIC_TOPOLOGY_SHOW_TAG: "Tag anzeigen",
  GRAPHIC_TOPOLOGY_SUBTITLE: "Anlagengeräte, Verbindungen und Bereiche organisieren",
  GRAPHIC_TOPOLOGY_TITLE: "Grafische Topologie",
  HAS_TS_EXPERT_EVENT: "Ist ein TS-Expert-Ereignis vorhanden?",
  HMI: "HMI",
  IP_PLACEHOLDER: "IP-Adresse (optional)",
  LOCALE_ADD_DESCRIPTION: "Klicken Sie auf eine freie Stelle, um ein neues Gerät hinzuzufügen.",
  LOCALE_ADD_EDGE: "Verbindung hinzufügen",
  LOCALE_ADD_NODE: "Gerät hinzufügen",
  LOCALE_BACK: "Zurück",
  LOCALE_CREATE_EDGE_ERROR: "Es kann keine Verbindung zu einem Cluster erstellt werden.",
  LOCALE_DEL: "Ausgewähltes Element entfernen",
  LOCALE_DELETE_CLUSTER_ERROR: "Cluster können nicht entfernt werden.",
  LOCALE_EDGE_DESCRIPTION: "Klicken Sie auf ein Gerät und ziehen Sie die Verbindung zu einem anderen Gerät, um beide zu verbinden.",
  LOCALE_EDIT: "Bearbeiten",
  LOCALE_EDIT_CLUSTER_ERROR: "Cluster können nicht bearbeitet werden.",
  LOCALE_EDIT_EDGE: "Verbindung bearbeiten",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Klicken und ziehen Sie die Kontrollpunkte zu einem Gerät, um die Verbindung herzustellen.",
  LOCALE_EDIT_NODE: "Gerät bearbeiten",
  MAX_JITTER: "Maximaler Jitter",
  MAX_PING: "Maximaler Ping",
  NO_DEVICE_SELECTED: "Kein Gerät ausgewählt",
  OPEN_DEVICE_IN_GRAPHIC_TOPOLOGY: "Dieses Gerät in der grafischen Topologie öffnen",
  PC: "Notebook",
  PS_2: "PS2:",
  PS_3: "PS3:",
  SELECTED_DEVICE: "Ausgewähltes Gerät",
  SERVER: "Server",
  SWITCH: "Switch",
  TABLE_TOPOLOGY: "Tabellarische Topologie",
  TAG_PLACEHOLDER: "TAG",
  TAP: "TAP",
  TOPOLOGY_CSV_EXPORT_NAME: "Topologie.xlsx",
  TOPOLOGY_CSV_HEADER: "SNMP,Name,Modell,IP,Port,Nachbarname,Nachbarport,Nachbar-IP\n",
  UNIQUE_DROPPED: "Einmalig verworfene Pakete",
  TS_EXPERT_SMART_DIAGNOSIS: "Intelligente PROFINET-Diagnose",
  TS_EXPERT_EVENT_TYPES: "Ereignistypen",
  TS_EXPERT_OCCURRENCES: "Vorkommen",
  TRAFFIC_CSV_HEADER: "IP,Name,Betriebszeit,Portname,Duplexmodus,Verzögerung,Schnittstellengeschwindigkeit,Eingehender Datenverkehr (Kbit/s),Eingehende Paketfehler,Ausgehender Datenverkehr (Kbit/s),Ausgehende Paketfehler,Portstatus\n",
  TRAFFIC_CSV_EXPORT_NAME: "Datenverkehr.xlsx",
});

export default Strings;
